import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: string;
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: string;
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library.  The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: string;
  /**
   * The `Naive DateTime` scalar type represents a naive date and time without
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string.
   */
  NaiveDateTime: string;
  /** Represents an uploaded file. */
  Upload: Blob;
};

export type AcquisitionChannel = {
  __typename: 'AcquisitionChannel';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type AllJobsStatistics = {
  __typename: 'AllJobsStatistics';
  averageMessageAcceptanceRate: Maybe<Scalars['Decimal']>;
  averageMessageNoResponseRate: Maybe<Scalars['Decimal']>;
  averageMessageRejectionRate: Maybe<Scalars['Decimal']>;
  totalNumberCandidatesMessaged: Maybe<Scalars['Int']>;
  totalNumberCandidatesShortlisted: Maybe<Scalars['Int']>;
};

export type AnswerQuestionData = {
  __typename: 'AnswerQuestionData';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
};

export type ApplicationQuestionResponseInput = {
  booleanResponse?: InputMaybe<Scalars['Boolean']>;
  dateResponse?: InputMaybe<Scalars['Date']>;
  decimalResponse?: InputMaybe<Scalars['Decimal']>;
  fileResponse?: InputMaybe<FileResponseInput>;
  multipleChoiceResponse?: InputMaybe<Array<InputMaybe<SingleChoiceResponseInput>>>;
  singleChoiceResponse?: InputMaybe<SingleChoiceResponseInput>;
  stringResponse?: InputMaybe<Scalars['String']>;
  urlResponse?: InputMaybe<Scalars['String']>;
};

export type AtsAnswerData = GreenhouseAnswerData | LeverAnswerData | OttaAnswerData | WorkableAnswerData;

export type AtsQuestionData = GreenhouseQuestionData | LeverQuestionData | OttaQuestionData | WorkableQuestionData;

export type BooleanAnswer = {
  __typename: 'BooleanAnswer';
  questionData: AnswerQuestionData;
  value: Scalars['Boolean'];
};

export type BooleanAnswerInput = {
  questionData: QuestionDataInput;
  value: Scalars['Boolean'];
};

export type BooleanQuestion = {
  __typename: 'BooleanQuestion';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type BooleanResponse = {
  __typename: 'BooleanResponse';
  value: Scalars['Boolean'];
};

export type BooleanValue = {
  __typename: 'BooleanValue';
  value: Scalars['Boolean'];
};

export type Boost = {
  __typename: 'Boost';
  type: ProductType;
  values: Array<BoostValues>;
};

export type BoostValues = {
  __typename: 'BoostValues';
  basicViews: Scalars['Int'];
  date: Scalars['Date'];
  isPro: Scalars['Boolean'];
  proViews: Scalars['Int'];
};

export type Candidate = {
  __typename: 'Candidate';
  activated: Scalars['Boolean'];
  atsProfileUrl: Maybe<Scalars['String']>;
  averageResponseTime: Maybe<Scalars['Int']>;
  companyQualitiesPreferences: Array<CompanyQualitiesPreference>;
  companySizePreferences: Array<CompanySizePreference>;
  companySubQualitiesPreferences: Array<CompanySubQualitiesPreference>;
  contextQuestionResponses: Array<CandidateContextQuestionResponse>;
  currentCompany: Maybe<Company>;
  currentTitle: Maybe<Scalars['String']>;
  discardedJobs: Array<Job>;
  discardedSubFunctions: Array<JobSubFunction>;
  diverse: Scalars['Boolean'];
  diversityMatch: Scalars['Boolean'];
  educationExperiences: Array<UserEducationExperience>;
  email: Scalars['String'];
  ethnicities: Array<Ethnicity>;
  externalId: Scalars['ID'];
  firstName: Scalars['String'];
  genders: Array<Gender>;
  hasSetPreferences: Maybe<Scalars['Boolean']>;
  hasSubmittedSalary: Scalars['Boolean'];
  hiddenCompanies: Array<HiddenCompany>;
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  /** @deprecated Use job_applications instead */
  internalJobApplications: Array<JobApplication>;
  jobApplications: Array<JobApplication>;
  jobEmailNotificationsFrequency: NotificationFrequency;
  jobExperiencePreference: Maybe<JobExperiencePreference>;
  /** @deprecated Renamed to job_experience_preference */
  jobExperiencePreferences: Maybe<UserJobExperiencePreferences>;
  jobFunctionPreferences: Array<JobFunctionPreference>;
  /** @deprecated Unused - see job reaction statistics */
  jobInteractionStatistics: JobInteractionStatistics;
  jobNotificationUnsubscription: Scalars['Boolean'];
  jobPreferenceSuggestions: Maybe<Array<JobPreferenceSuggestion>>;
  jobReactionStatistics: JobReactionStatistics;
  jobRecommendations: Array<JobRecommendation>;
  jobSubFunctionPreferences: Array<JobSubFunctionPreference>;
  jobsProcessed: Maybe<Scalars['Int']>;
  languageRequirementPreferences: Array<LanguageRequirementPreference>;
  lastActive: Scalars['NaiveDateTime'];
  lastName: Scalars['String'];
  lastUnconfirmedJobApplication: Maybe<Scalars['String']>;
  linkedinUrl: Maybe<Scalars['String']>;
  locationPreferences: Array<LocationPreference>;
  marketingConsent: Scalars['Boolean'];
  messageRequestsSentFromCompany: Array<CandidateMessageRequest>;
  /** @deprecated Use min_salary_requirement instead */
  minSalaryPreference: Maybe<Scalars['Int']>;
  minSalaryRequirement: Maybe<Money>;
  mostRecentJobInterview: Maybe<CandidateJobInterview>;
  numReferrals: Maybe<Scalars['Int']>;
  numUnreadShortlistedJobs: Scalars['Int'];
  permissions: Array<PermissionObject>;
  phoneNumber: Maybe<Scalars['String']>;
  profileCompletion: Array<ProfileCompletionComponent>;
  profileImagePath: Maybe<Scalars['String']>;
  profileInterests: Maybe<Scalars['String']>;
  projects: Array<UserProject>;
  pronoun: Maybe<Pronoun>;
  receivedMessageRequests: Array<CandidateMessageRequest>;
  region: Maybe<Scalars['String']>;
  retained: Scalars['Boolean'];
  role: RoleType;
  savedJobsAtCompany: Array<PublicJob>;
  savedSimilarCompanies: Array<PublicCompany>;
  searchStage: Maybe<Scalars['String']>;
  sectorTagPreferences: Array<SectorTagPreference>;
  sexualOrientation: Maybe<SexualOrientation>;
  shortlisted: Scalars['Boolean'];
  shortlistedJobs: Array<Job>;
  showProfileToCompanies: Scalars['Boolean'];
  showRequestAdvice: Maybe<Scalars['Boolean']>;
  signUpReasonResponses: Array<SignUpReasonResponse>;
  signupRegion: Maybe<Scalars['String']>;
  signupSubregion: Maybe<Scalars['String']>;
  subregion: Maybe<Scalars['String']>;
  technologiesUsedPreferences: Array<TechnologyUsedPreference>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
  timezone: Maybe<Timezone>;
  /** @deprecated Deprecated */
  topCandidate: Scalars['Boolean'];
  totalDiscardedJobs: Maybe<Scalars['Int']>;
  totalJobApplicationClicks: Scalars['Int'];
  totalJobApplicationConfirms: Scalars['Int'];
  totalJobReactions: Scalars['Int'];
  totalRemainingJobs: Scalars['Int'];
  verifiedEmail: Scalars['Boolean'];
  visaRequirementCountries: Array<VisaRequirementCountry>;
  websiteLinks: Array<WebsiteLink>;
  workExperiences: Array<UserWorkExperience>;
};


export type CandidateAtsProfileUrlArgs = {
  jobId: Scalars['ID'];
};


export type CandidateDiscardedJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateDiversityMatchArgs = {
  filters?: InputMaybe<PersonalisedCandidateFilters>;
};


export type CandidateJobApplicationsArgs = {
  applied?: InputMaybe<Scalars['Boolean']>;
  appliedAtGt?: InputMaybe<Scalars['DateTime']>;
  appliedAtLt?: InputMaybe<Scalars['DateTime']>;
  externalOrSentToAts?: InputMaybe<Scalars['Boolean']>;
  externalResponded?: InputMaybe<Array<ExternalResponded>>;
  internal?: InputMaybe<Scalars['Boolean']>;
  orderByLeastResponseRateDatapoints?: InputMaybe<Scalars['Boolean']>;
  stillApplied?: InputMaybe<Scalars['Boolean']>;
};


export type CandidateJobInteractionStatisticsArgs = {
  since: Scalars['NaiveDateTime'];
};


export type CandidateJobRecommendationsArgs = {
  ignoreSubfunctions?: InputMaybe<Scalars['Boolean']>;
  preferredSectorId?: InputMaybe<Scalars['ID']>;
  sectorTagIds?: InputMaybe<Array<Scalars['Int']>>;
  themeId?: InputMaybe<ThemeId>;
};


export type CandidateJobsProcessedArgs = {
  since: Scalars['DateTime'];
};


export type CandidateProfileImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type CandidateShortlistedArgs = {
  jobId: Scalars['ID'];
};


export type CandidateTopCandidateArgs = {
  jobId: Scalars['ID'];
};


export type CandidateTotalRemainingJobsArgs = {
  ignoreSubfunctions?: InputMaybe<Scalars['Boolean']>;
  sectorTagIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CandidateContextQuestion = {
  __typename: 'CandidateContextQuestion';
  id: Scalars['ID'];
  placeholder: Scalars['String'];
  question: Scalars['String'];
  response: Maybe<CandidateContextQuestionResponse>;
};

export type CandidateContextQuestionResponse = {
  __typename: 'CandidateContextQuestionResponse';
  featuredAnswer: Scalars['Boolean'];
  id: Scalars['ID'];
  question: CandidateContextQuestion;
  value: Scalars['String'];
};

export type CandidateConversation = {
  __typename: 'CandidateConversation';
  id: Scalars['ID'];
  jobApplication: Maybe<JobApplication>;
  latestMessage: Maybe<CandidateConversationMessage>;
  messageRequest: Maybe<CandidateMessageRequest>;
  messages: Array<CandidateConversationMessage>;
  qualified: Maybe<Scalars['Boolean']>;
  read: Scalars['Boolean'];
};

export type CandidateConversationMessage = {
  __typename: 'CandidateConversationMessage';
  candidateConversationId: Scalars['ID'];
  content: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  read: Scalars['Boolean'];
  sender: User;
};

export type CandidateJobInterview = {
  __typename: 'CandidateJobInterview';
  companySectorTags: Array<SectorTag>;
  jobSubFunction: JobSubFunction;
};

export type CandidateMessageRequest = {
  __typename: 'CandidateMessageRequest';
  accepted: Maybe<Scalars['Boolean']>;
  candidate: Candidate;
  companyRecruiter: User;
  conversation: Maybe<CandidateConversation>;
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  job: Job;
  lastActionAt: Scalars['NaiveDateTime'];
  latestConversationMessage: Maybe<CandidateConversationMessage>;
};

export type CandidatePipelineItem = {
  __typename: 'CandidatePipelineItem';
  candidate: Maybe<PipelineCandidate>;
  candidateId: Maybe<Scalars['ID']>;
  candidatePipelineItemNote: Maybe<CandidatePipelineItemNote>;
  conversation: Maybe<CompanyConversation>;
  id: Scalars['ID'];
  importedCandidate: Maybe<ImportedCandidate>;
  importedCandidateId: Maybe<Scalars['ID']>;
  jobApplication: Maybe<JobApplication>;
  latestMessage: Maybe<ConversationMessage>;
  messageRequest: Maybe<CandidateMessageRequest>;
  movedToStageAt: Scalars['NaiveDateTime'];
  stageName: Scalars['String'];
  stageType: StageType;
};

export type CandidatePipelineItemNote = {
  __typename: 'CandidatePipelineItemNote';
  content: Scalars['String'];
  createdBy: Maybe<User>;
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  lastUpdatedBy: Maybe<User>;
  updatedAt: Scalars['NaiveDateTime'];
};

export type CandidatePipelineStage = {
  __typename: 'CandidatePipelineStage';
  candidatePipelineItems: Maybe<Array<CandidatePipelineItem>>;
  deletedAt: Maybe<Scalars['NaiveDateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  position: Scalars['String'];
  stageType: StageType;
};

export type CandidatePipelineStagePartial = {
  __typename: 'CandidatePipelineStagePartial';
  currentCandidateInStage: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  stageType: StageType;
};

/** The possible options for candidates related to a job */
export enum CandidateStatus {
  /** The candidate has applied to the job */
  Applied = 'APPLIED',
  /** The candidate has either applied to the job or been sourced through Otta */
  AppliedOrSourced = 'APPLIED_OR_SOURCED'
}

export type Choice = {
  __typename: 'Choice';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ChoiceInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export type CommonUser = {
  __typename: 'CommonUser';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  notification: Maybe<Notification>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
};

export type Company = {
  __typename: 'Company';
  acquisitionChannels: Array<AcquisitionChannel>;
  additionalInfoBullets: Array<CompanyAdditionalInfoBullet>;
  /** @deprecated Use list_jobs instead */
  allJobs: Maybe<Array<Job>>;
  allJobsStatistics: AllJobsStatistics;
  angelListUrl: Maybe<Scalars['String']>;
  articles: Array<CompanyArticle>;
  ats: Maybe<CompanyAts>;
  atsApiKey: Maybe<Scalars['String']>;
  atsApiKeys: Array<CompanyAtsApiKey>;
  atsAuthorizeUrl: Maybe<Scalars['String']>;
  atsWebhooks: Array<CompanyAtsWebhook>;
  bcorp: Scalars['Boolean'];
  changes: Array<CompanyChange>;
  companiesHouseName: Maybe<Scalars['String']>;
  companyRecruiters: Array<CompanyRecruiter>;
  createdAt: Scalars['NaiveDateTime'];
  crunchbaseUrl: Maybe<Scalars['String']>;
  dealroomId: Maybe<Scalars['String']>;
  diversityAuthorFullName: Maybe<Scalars['String']>;
  diversityAuthorProfileImagePath: Maybe<Scalars['String']>;
  diversityAuthorTitle: Maybe<Scalars['String']>;
  diversityInitiatives: Array<CompanyDiversityInitiative>;
  domainName: Maybe<Scalars['String']>;
  employeeSurveys: Array<CompanyEmployeeSurvey>;
  externalId: Scalars['String'];
  faviconPath: Maybe<Scalars['String']>;
  featuredRecruiter: Maybe<PublicCompanyRecruiter>;
  /** @deprecated Field no longer used */
  feedbackPercentile: Maybe<Scalars['Decimal']>;
  founders: Array<CompanyFounder>;
  fundingRounds: Array<CompanyFundingRound>;
  glassdoorRating: Maybe<Scalars['Decimal']>;
  glassdoorUrl: Maybe<Scalars['String']>;
  hasAtsIntegration: Scalars['Boolean'];
  hqAddress: Maybe<Scalars['String']>;
  hubspotId: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integratedWithDealroom: Scalars['Boolean'];
  interviewExperience: Maybe<InterviewExperience>;
  investors: Array<Investor>;
  isEligibleForOttaPro: Scalars['Boolean'];
  isPro: Scalars['Boolean'];
  jobApplications: Array<JobApplication>;
  jobLocations: Array<Location>;
  /** @deprecated Use :live_jobs instead, jobs should be a generic query for admins and recruiters */
  jobs: Array<Job>;
  /** @deprecated Unused */
  jobsWithFeedback: Array<Job>;
  jobsWithSalaryStats: JobsWithSalaryStats;
  lastWorkflowStatusChangeBy: Maybe<User>;
  linkedinUrl: Maybe<Scalars['String']>;
  /** @deprecated Rename to :jobs when the current :jobs is deprecated */
  listJobs: Array<Job>;
  liveJobs: Array<Job>;
  logoPath: Maybe<Scalars['String']>;
  marketBullets: Array<CompanyMarketBullet>;
  maxDaysInOffice: Maybe<Scalars['Int']>;
  minDaysInOffice: Maybe<Scalars['Int']>;
  mission: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberEmployeeSurveys: Maybe<Scalars['Int']>;
  numberEmployees: Maybe<Scalars['Int']>;
  /** @deprecated Unused */
  numberHistoricalJobs: Scalars['Int'];
  numberLiveJobs: Scalars['Int'];
  numberLiveJobsWithSalary: Scalars['Int'];
  numberOfEndorsements: Scalars['Int'];
  numberOfUnactionedApplications: Scalars['Int'];
  numberOfUnreadMessages: Scalars['Int'];
  oldestLiveJobWithoutPublicSalary: Maybe<Job>;
  otherBenefits: Array<CompanyOtherBenefit>;
  ottaCertified: Scalars['Boolean'];
  parsedHqAddress: Maybe<Scalars['String']>;
  paused: Maybe<Scalars['Boolean']>;
  peopleProgressing: Array<CompanyPersonProgressing>;
  percentageFemale: Maybe<Scalars['Int']>;
  photos: Array<Photo>;
  primaryColour: Maybe<Scalars['String']>;
  /** @deprecated Use is_pro instead */
  proTier: Scalars['Boolean'];
  products: Array<Product>;
  receivesApplicationsWithinOtta: Scalars['Boolean'];
  recruiters: Array<CommonUser>;
  responseCountByCategory: Array<CompanyEmployeeSurveyResponseCountForCategory>;
  responseRate: Maybe<Scalars['Decimal']>;
  rocketListEntries: Array<RocketListEntry>;
  scraperUrl: Maybe<Scalars['String']>;
  sectorTags: Array<SectorTag>;
  shortDescription: Maybe<Scalars['String']>;
  size: Maybe<CompanySize>;
  statistics: Maybe<CompanyStatistics>;
  totalFunding: Maybe<Money>;
  totalJobReactions: Maybe<Scalars['Int']>;
  trackingCode: Maybe<Scalars['String']>;
  trustpilotRating: Maybe<Scalars['Decimal']>;
  trustpilotUrl: Maybe<Scalars['String']>;
  urlSafeName: Scalars['String'];
  values: Array<CompanyValue>;
  visaSponsorshipCountries: Array<VisaSponsorshipCountry>;
  websiteUrl: Maybe<Scalars['String']>;
  workflowStatus: CompanyWorkflowStatus;
  yearEmployeeGrowthPercentage: Maybe<Scalars['Int']>;
};


export type CompanyAllJobsArgs = {
  groupWorkflowStatus?: InputMaybe<GroupWorkflowStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type CompanyAllJobsStatisticsArgs = {
  groupWorkflowStatus?: InputMaybe<GroupWorkflowStatus>;
  timePeriod?: InputMaybe<Scalars['DateTime']>;
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type CompanyDiversityAuthorProfileImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type CompanyFaviconPathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type CompanyFundingRoundsArgs = {
  currency?: InputMaybe<Currency>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type CompanyInvestorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  onlyTop?: InputMaybe<Scalars['Boolean']>;
};


export type CompanyJobApplicationsArgs = {
  applied?: InputMaybe<Scalars['Boolean']>;
  appliedAtGt?: InputMaybe<Scalars['DateTime']>;
  appliedAtLt?: InputMaybe<Scalars['DateTime']>;
  externalOrSentToAts?: InputMaybe<Scalars['Boolean']>;
  externalResponded?: InputMaybe<Array<ExternalResponded>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanyJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanyListJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['String']>>;
  workflowStatuses?: InputMaybe<Array<JobWorkflowStatus>>;
};


export type CompanyLiveJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CompanyLogoPathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type CompanyTotalFundingArgs = {
  currency?: InputMaybe<Currency>;
};

export type CompanyAcquisitionChannelInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type CompanyAdditionalInfoBullet = {
  __typename: 'CompanyAdditionalInfoBullet';
  id: Scalars['ID'];
  value: Maybe<Scalars['String']>;
};

export type CompanyArticle = {
  __typename: 'CompanyArticle';
  id: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CompanyArticleInput = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** The ATSs with which we integrate */
export enum CompanyAts {
  Greenhouse = 'GREENHOUSE',
  Lever = 'LEVER',
  Workable = 'WORKABLE'
}

export type CompanyAtsApiKey = {
  __typename: 'CompanyAtsApiKey';
  id: Scalars['ID'];
  key: Scalars['String'];
  type: CompanyAtsApiKeyTypeEnum;
};

/** The possible options for the api key type */
export enum CompanyAtsApiKeyTypeEnum {
  GreenhouseHarvest = 'GREENHOUSE_HARVEST',
  GreenhouseJobBoard = 'GREENHOUSE_JOB_BOARD'
}

export type CompanyAtsWebhook = {
  __typename: 'CompanyAtsWebhook';
  ats: CompanyAts;
  id: Scalars['ID'];
  key: Scalars['String'];
  lastRequestedAt: Maybe<Scalars['DateTime']>;
  requestedTopic: Maybe<Scalars['String']>;
  secretKey: Maybe<Scalars['String']>;
  subscriptionId: Maybe<Scalars['String']>;
};

export type CompanyChange = {
  __typename: 'CompanyChange';
  dismissedAt: Maybe<Scalars['DateTime']>;
  fieldName: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  newValue: Maybe<CompanyChangeValue>;
  oldValue: Maybe<CompanyChangeValue>;
  user: Maybe<User>;
};

export type CompanyChangeValue = BooleanValue | DatetimeValue | DecimalValue | IntegerValue | StringListValue | StringValue;

export type CompanyConversation = {
  __typename: 'CompanyConversation';
  archived: Scalars['Boolean'];
  closed: Scalars['Boolean'];
  conversationId: Maybe<Scalars['ID']>;
  favourited: Scalars['Boolean'];
  hasAcceptedRequest: Maybe<Scalars['Boolean']>;
  job: Job;
  jobApplication: Maybe<JobApplication>;
  jobApplicationId: Maybe<Scalars['ID']>;
  latestMessage: Maybe<ConversationMessage>;
  messages: Array<ConversationMessage>;
  recipient: User;
  sourced: Scalars['Boolean'];
};

export type CompanyDiversityInitiative = {
  __typename: 'CompanyDiversityInitiative';
  id: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type CompanyDiversityInitiativeInput = {
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type CompanyEmployeeSurvey = {
  __typename: 'CompanyEmployeeSurvey';
  company: Company;
  id: Scalars['ID'];
  isApproved: Maybe<Scalars['Boolean']>;
  jobFunction: JobFunction;
  responses: Array<CompanyEmployeeSurveyCategoryResponse>;
  submittedAt: Maybe<Scalars['Date']>;
};

export type CompanyEmployeeSurveyCategoryResponse = {
  __typename: 'CompanyEmployeeSurveyCategoryResponse';
  category: CompanySubQuality;
  content: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CompanyEmployeeSurveyCategoryResponseInput = {
  categoryId: Scalars['ID'];
  content?: InputMaybe<Scalars['String']>;
};

export type CompanyEmployeeSurveyResponseCountForCategory = {
  __typename: 'CompanyEmployeeSurveyResponseCountForCategory';
  categoryName: Scalars['String'];
  count: Scalars['Int'];
  id: Scalars['ID'];
};

export type CompanyFounder = {
  __typename: 'CompanyFounder';
  bio: Maybe<Scalars['String']>;
  gender: Maybe<Gender>;
  id: Scalars['ID'];
  linkedinUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
  title: Scalars['String'];
};

export type CompanyFounderInput = {
  bio?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CompanyFundingRound = {
  __typename: 'CompanyFundingRound';
  funding: FundingAmount;
  id: Scalars['ID'];
  month: Scalars['Int'];
  round: Maybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type CompanyFundingRoundInput = {
  funding?: InputMaybe<FundingAmountInput>;
  month?: InputMaybe<Scalars['Int']>;
  round?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type CompanyInput = {
  acquisitionChannels?: InputMaybe<Array<CompanyAcquisitionChannelInput>>;
  angelListUrl?: InputMaybe<Scalars['String']>;
  articles?: InputMaybe<Array<CompanyArticleInput>>;
  atsApiKey?: InputMaybe<Scalars['String']>;
  bcorp?: InputMaybe<Scalars['Boolean']>;
  companiesHouseName?: InputMaybe<Scalars['String']>;
  crunchbaseUrl?: InputMaybe<Scalars['String']>;
  dealroomId?: InputMaybe<Scalars['String']>;
  diversityAuthorFullName?: InputMaybe<Scalars['String']>;
  diversityAuthorProfileImagePath?: InputMaybe<Scalars['String']>;
  diversityAuthorTitle?: InputMaybe<Scalars['String']>;
  diversityInitiatives?: InputMaybe<Array<CompanyDiversityInitiativeInput>>;
  faviconPath?: InputMaybe<Scalars['String']>;
  founders?: InputMaybe<Array<CompanyFounderInput>>;
  fundingRounds?: InputMaybe<Array<CompanyFundingRoundInput>>;
  glassdoorRating?: InputMaybe<Scalars['Decimal']>;
  glassdoorUrl?: InputMaybe<Scalars['String']>;
  hqAddress?: InputMaybe<Scalars['String']>;
  hubspotId?: InputMaybe<Scalars['String']>;
  internalJobApplications?: InputMaybe<Scalars['Boolean']>;
  investors?: InputMaybe<Array<InvestorInput>>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  logoPath?: InputMaybe<Scalars['String']>;
  maxDaysInOffice?: InputMaybe<Scalars['Int']>;
  minDaysInOffice?: InputMaybe<Scalars['Int']>;
  mission?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  numberEmployees?: InputMaybe<Scalars['Int']>;
  otherBenefits?: InputMaybe<Array<CompanyOtherBenefitInput>>;
  parsedHqAddress?: InputMaybe<Scalars['String']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  peopleProgressing?: InputMaybe<Array<CompanyPersonProgressingInput>>;
  percentageFemale?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<Array<PhotoInput>>;
  primaryColour?: InputMaybe<Scalars['String']>;
  proTier?: InputMaybe<Scalars['Boolean']>;
  scraperUrl?: InputMaybe<Scalars['String']>;
  sectorTags?: InputMaybe<Array<SectorTagInput>>;
  shortDescription?: InputMaybe<Scalars['String']>;
  totalFunding?: InputMaybe<MoneyInput>;
  trackingCode?: InputMaybe<Scalars['String']>;
  trustpilotRating?: InputMaybe<Scalars['Decimal']>;
  trustpilotUrl?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<CompanyValueInput>>;
  visaSponsorshipCountries?: InputMaybe<Array<VisaSponsorshipCountryInput>>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  yearEmployeeGrowthPercentage?: InputMaybe<Scalars['Int']>;
};

export type CompanyJobApplicationInput = {
  accepted: Scalars['Boolean'];
  message: Scalars['String'];
};

export type CompanyJobInput = {
  applicationProcessBullets?: InputMaybe<Array<JobApplicationProcessBulletInput>>;
  editedTitle?: InputMaybe<Scalars['String']>;
  functionId?: InputMaybe<Scalars['ID']>;
  hideSalary?: InputMaybe<Scalars['Boolean']>;
  internship?: InputMaybe<Scalars['Boolean']>;
  involvesBullets?: InputMaybe<Array<JobInvolvesBulletInput>>;
  languageRequirements?: InputMaybe<Array<JobLanguageRequirementInput>>;
  locationInformation?: InputMaybe<Scalars['String']>;
  locationPreferences?: InputMaybe<Array<LocationPreferenceInput>>;
  locationRestrictions?: InputMaybe<Scalars['String']>;
  maxDaysInOffice?: InputMaybe<Scalars['Int']>;
  maxYearsExperienceRequired?: InputMaybe<Scalars['Int']>;
  minDaysInOffice?: InputMaybe<Scalars['Int']>;
  minYearsExperienceRequired?: InputMaybe<Scalars['Int']>;
  officeLocation?: InputMaybe<Scalars['String']>;
  oteSalaryRange?: InputMaybe<MoneyRangeInput>;
  otherCompensationInformation?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Array<JobRequirementInput>>;
  salaryRange?: InputMaybe<MoneyRangeInput>;
  subFunctionId?: InputMaybe<Scalars['ID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  technologiesUsed?: InputMaybe<Array<JobTechnologyUsedInput>>;
};

export type CompanyMarketBullet = {
  __typename: 'CompanyMarketBullet';
  id: Scalars['ID'];
  value: Maybe<Scalars['String']>;
};

export type CompanyOtherBenefit = {
  __typename: 'CompanyOtherBenefit';
  id: Scalars['ID'];
  location: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type CompanyOtherBenefitInput = {
  location?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CompanyPersonProgressing = {
  __typename: 'CompanyPersonProgressing';
  bio: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkedinUrl: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CompanyPersonProgressingInput = {
  bio?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CompanyQualitiesPreference = {
  __typename: 'CompanyQualitiesPreference';
  companyQualityId: Scalars['ID'];
};

export type CompanyQualitiesPreferenceInput = {
  companyQualityId: Scalars['ID'];
};

export type CompanyQuality = {
  __typename: 'CompanyQuality';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type CompanyRecruiter = {
  __typename: 'CompanyRecruiter';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastActive: Maybe<Scalars['NaiveDateTime']>;
  lastName: Scalars['String'];
  notification: Maybe<Notification>;
  profileImagePath: Maybe<Scalars['String']>;
  role: CompanyRoleType;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
  viewSalaryForJob: Scalars['Boolean'];
};


export type CompanyRecruiterProfileImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type CompanyRecruiterViewSalaryForJobArgs = {
  jobId: Scalars['ID'];
};

/** The possible options for the role of a user */
export enum CompanyRoleType {
  /** The company recruiter has admin access */
  Admin = 'ADMIN',
  /** The company recruiter only has member access */
  Member = 'MEMBER'
}

export type CompanySize = {
  __typename: 'CompanySize';
  id: Scalars['ID'];
  value: Maybe<Scalars['String']>;
};

export type CompanySizePreference = {
  __typename: 'CompanySizePreference';
  companySize: CompanySize;
  companySizeId: Scalars['ID'];
};

export type CompanySizePreferenceInput = {
  companySizeId: Scalars['ID'];
};

export type CompanyStatistics = {
  __typename: 'CompanyStatistics';
  jobs: Array<JobWithStatistics>;
};

export type CompanySubQualitiesPreference = {
  __typename: 'CompanySubQualitiesPreference';
  companySubQualityId: Scalars['ID'];
};

export type CompanySubQuality = {
  __typename: 'CompanySubQuality';
  id: Scalars['ID'];
  name: Scalars['String'];
  placeholderText: Scalars['String'];
};

export type CompanyValue = {
  __typename: 'CompanyValue';
  id: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  value: Maybe<Scalars['String']>;
};

export type CompanyValueInput = {
  order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** The workflow status of a company */
export enum CompanyWorkflowStatus {
  /** A company that is a good fit for the platform */
  Approved = 'APPROVED',
  /** A company which is not to be shown or completed. */
  Archived = 'ARCHIVED',
  /** A completed company which needs reviewing. */
  Changed = 'CHANGED',
  /** A completed company which can be shown on the platform. */
  Completed = 'COMPLETED',
  /** A company that has requested access to the platform. */
  PreApproval = 'PRE_APPROVAL',
  /** A company that is a may be a good fit for the platform but are having a sales call */
  PushedToPro = 'PUSHED_TO_PRO',
  /** A company ready to be QA'd internally. */
  QaInternal = 'QA_INTERNAL',
  /** A company ready to be completed. */
  Queued = 'QUEUED'
}

export type Conversation = {
  __typename: 'Conversation';
  closed: Scalars['Boolean'];
  hasAcceptedRequest: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  job: Job;
  jobApplication: Maybe<JobApplication>;
  latestMessage: ConversationMessage;
  messages: Array<ConversationMessage>;
  sourced: Scalars['Boolean'];
};

export type ConversationMessage = {
  __typename: 'ConversationMessage';
  candidateConversationId: Scalars['ID'];
  content: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  read: Scalars['Boolean'];
  sender: User;
};

/** The possible options for a message stage */
export enum ConversationStage {
  /** Messages between a recruiter and a candidate who has sent an application. */
  Applied = 'APPLIED',
  /** Messages between a recruiter and a candidate who has been moved to the qualified stage, either from sourced or applied. */
  Qualified = 'QUALIFIED',
  /** Messages between a recruiter and a sourced candidate. */
  Sourced = 'SOURCED'
}

export enum CreationMethod {
  Admin = 'ADMIN',
  Ats = 'ATS',
  Candidate = 'CANDIDATE',
  CompanyRecruiter = 'COMPANY_RECRUITER'
}

/** Supported currencies */
export enum Currency {
  Cad = 'CAD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CurrentAdmin = CurrentUser & {
  __typename: 'CurrentAdmin';
  companyConversations: Array<CompanyConversation>;
  conversations: Array<Conversation>;
  currentCompany: Maybe<Company>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  hasUnactionedMessages: Scalars['Boolean'];
  id: Scalars['ID'];
  jobsProcessed: Maybe<Scalars['Int']>;
  lastName: Scalars['String'];
  linkedinUrl: Maybe<Scalars['String']>;
  notification: Maybe<Notification>;
  numUnreadShortlistedJobs: Maybe<Scalars['Int']>;
  profileStatus: Maybe<ProfileStatus>;
  searchStage: Maybe<Scalars['String']>;
  showProfileToCompanies: Maybe<Scalars['Boolean']>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
  themedBatchCount: Scalars['Int'];
  topSector: Maybe<SectorTag>;
  workExperiences: Array<UserWorkExperience>;
};


export type CurrentAdminCompanyConversationsArgs = {
  allMessages?: InputMaybe<Scalars['Boolean']>;
  applied?: InputMaybe<Scalars['Boolean']>;
  favourites?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  onlyArchivedMessages?: InputMaybe<Scalars['Boolean']>;
  onlyAwaitingResponse?: InputMaybe<Scalars['Boolean']>;
  sourced?: InputMaybe<Scalars['Boolean']>;
};


export type CurrentAdminJobsProcessedArgs = {
  since: Scalars['DateTime'];
};


export type CurrentAdminThemedBatchCountArgs = {
  preferredSectorId?: InputMaybe<Scalars['ID']>;
  themeId: ThemeId;
};

export type CurrentCandidate = CurrentUser & {
  __typename: 'CurrentCandidate';
  conversations: Array<Conversation>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  hasUnactionedMessages: Scalars['Boolean'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  linkedinUrl: Maybe<Scalars['String']>;
  notification: Maybe<Notification>;
  numUnreadShortlistedJobs: Maybe<Scalars['Int']>;
  profileStatus: Maybe<ProfileStatus>;
  searchStage: Maybe<Scalars['String']>;
  showProfileToCompanies: Maybe<Scalars['Boolean']>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
  themedBatchCount: Scalars['Int'];
  topSector: Maybe<SectorTag>;
  workExperiences: Array<UserWorkExperience>;
};


export type CurrentCandidateThemedBatchCountArgs = {
  preferredSectorId?: InputMaybe<Scalars['ID']>;
  themeId: ThemeId;
};

export type CurrentCompanyRecruiter = CurrentUser & {
  __typename: 'CurrentCompanyRecruiter';
  companyConversations: Array<CompanyConversation>;
  currentCompany: Maybe<Company>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastActive: Maybe<Scalars['NaiveDateTime']>;
  lastName: Scalars['String'];
  notification: Maybe<Notification>;
  profileImagePath: Maybe<Scalars['String']>;
  role: CompanyRoleType;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
  viewSalaryForJob: Scalars['Boolean'];
};


export type CurrentCompanyRecruiterCompanyConversationsArgs = {
  allMessages?: InputMaybe<Scalars['Boolean']>;
  applied?: InputMaybe<Scalars['Boolean']>;
  favourites?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  onlyArchivedMessages?: InputMaybe<Scalars['Boolean']>;
  onlyAwaitingResponse?: InputMaybe<Scalars['Boolean']>;
  sourced?: InputMaybe<Scalars['Boolean']>;
};


export type CurrentCompanyRecruiterProfileImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type CurrentCompanyRecruiterViewSalaryForJobArgs = {
  jobId: Scalars['ID'];
};

export type CurrentExternalResearcher = CurrentUser & {
  __typename: 'CurrentExternalResearcher';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  notification: Maybe<Notification>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
};

export type CurrentInternalOperator = CurrentUser & {
  __typename: 'CurrentInternalOperator';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  jobsProcessed: Maybe<Scalars['Int']>;
  lastName: Scalars['String'];
  notification: Maybe<Notification>;
  permissions: Array<Scalars['String']>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
};


export type CurrentInternalOperatorJobsProcessedArgs = {
  since: Scalars['DateTime'];
};

export type CurrentUser = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  notification: Maybe<Notification>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
};

export type DateAnswer = {
  __typename: 'DateAnswer';
  questionData: AnswerQuestionData;
  value: Scalars['Date'];
};

export type DateAnswerInput = {
  questionData: QuestionDataInput;
  value: Scalars['Date'];
};

export type DateQuestion = {
  __typename: 'DateQuestion';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type DateResponse = {
  __typename: 'DateResponse';
  date: Scalars['Date'];
};

export type DatetimeValue = {
  __typename: 'DatetimeValue';
  value: Scalars['DateTime'];
};

export type DecimalAnswer = {
  __typename: 'DecimalAnswer';
  questionData: AnswerQuestionData;
  value: Scalars['Decimal'];
};

export type DecimalAnswerInput = {
  questionData: QuestionDataInput;
  value: Scalars['Decimal'];
};

export type DecimalQuestion = {
  __typename: 'DecimalQuestion';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type DecimalResponse = {
  __typename: 'DecimalResponse';
  value: Scalars['Decimal'];
};

export type DecimalValue = {
  __typename: 'DecimalValue';
  value: Scalars['Decimal'];
};

/** The types of device platform the mobile app is available on */
export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type DislikedSectorPreferenceSuggestion = JobPreferenceSuggestion & {
  __typename: 'DislikedSectorPreferenceSuggestion';
  id: Scalars['ID'];
  sectorTag: SectorTag;
};

export type DislikedTechnologyPreferenceSuggestion = JobPreferenceSuggestion & {
  __typename: 'DislikedTechnologyPreferenceSuggestion';
  id: Scalars['ID'];
  technology: JobTechnologyUsed;
};

export type EducationExperienceDescription = {
  __typename: 'EducationExperienceDescription';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type EducationExperienceDescriptionInput = {
  value: Scalars['String'];
};

export type Ethnicity = {
  __typename: 'Ethnicity';
  ethnicity: EthnicityEnum;
  id: Scalars['ID'];
};

/** The possible options for ethnicity */
export enum EthnicityEnum {
  Asian = 'ASIAN',
  /** Black or African American */
  Black = 'BLACK',
  EastAsian = 'EAST_ASIAN',
  Hispanic = 'HISPANIC',
  IndigenousPeoples = 'INDIGENOUS_PEOPLES',
  MiddleEastern = 'MIDDLE_EASTERN',
  /** Multiracial / Multiethnic */
  Mixed = 'MIXED',
  NativeHawaiian = 'NATIVE_HAWAIIAN',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  SoutheastAsian = 'SOUTHEAST_ASIAN',
  SouthAsian = 'SOUTH_ASIAN',
  White = 'WHITE'
}

export type EthnicityInput = {
  ethnicity: EthnicityEnum;
};

export type ExistingFileAnswerInput = {
  name: Scalars['String'];
  questionData: QuestionDataInput;
  url: Scalars['String'];
};

/** The possible options for an experience level */
export enum ExperienceLevel {
  /** Entry level experience */
  EntryLevel = 'ENTRY_LEVEL',
  /** Five to eight years experience level */
  FiveToEightYears = 'FIVE_TO_EIGHT_YEARS',
  /** Internship experience level */
  Internship = 'INTERNSHIP',
  /** Nine plus years experience level */
  NinePlusYears = 'NINE_PLUS_YEARS',
  /** One to two years experience level */
  OneToTwoYears = 'ONE_TO_TWO_YEARS',
  /** Three to four years experience level */
  ThreeToFourYears = 'THREE_TO_FOUR_YEARS'
}

export type ExperienceRange = {
  maxYearsExperienceRequired: Scalars['Int'];
  minYearsExperienceRequired: Scalars['Int'];
};

/** Options for external responded */
export enum ExternalResponded {
  No = 'NO',
  Unanswered = 'UNANSWERED',
  Yes = 'YES'
}

export type FeatureFlag = {
  __typename: 'FeatureFlag';
  name: Scalars['String'];
  variants: Array<Scalars['String']>;
};

export type File = {
  __typename: 'File';
  path: Maybe<Scalars['String']>;
};

export type FileAnswer = {
  __typename: 'FileAnswer';
  contentType: Scalars['String'];
  name: Scalars['String'];
  questionData: AnswerQuestionData;
  url: Scalars['String'];
};

export type FileQuestion = {
  __typename: 'FileQuestion';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type FileResponse = {
  __typename: 'FileResponse';
  contentType: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type FileResponseInput = {
  file: Scalars['Upload'];
  name: Scalars['String'];
};

export type FundingAmount = {
  __typename: 'FundingAmount';
  amount: Scalars['Int'];
  currency: Scalars['String'];
};

export type FundingAmountInput = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
};

/** The possible options for gender */
export enum Gender {
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE',
  /** Non binary */
  NonBinary = 'NON_BINARY',
  /** Other */
  Other = 'OTHER',
  /** Prefer not to say */
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  /** Transgender */
  Transgender = 'TRANSGENDER'
}

export type GreenhouseAnswer = FileAnswer | MultiSelectAnswer | SingleSelectAnswer | TextAnswer | TextAreaAnswer;

export type GreenhouseAnswerData = {
  __typename: 'GreenhouseAnswerData';
  answers: Array<GreenhouseAnswer>;
  demographicAnswers: Array<GreenhouseDemographicAnswer>;
};

export type GreenhouseAnswerInput = {
  existingFileAnswer?: InputMaybe<ExistingFileAnswerInput>;
  fileAnswer?: InputMaybe<NewFileAnswerInput>;
  multiSelectAnswer?: InputMaybe<MultiSelectAnswerInput>;
  singleSelectAnswer?: InputMaybe<SingleSelectAnswerInput>;
  textAnswer?: InputMaybe<TextAnswerInput>;
  textAreaAnswer?: InputMaybe<TextAreaAnswerInput>;
};

export type GreenhouseApplicationQuestion = FileQuestion | MultiSelectQuestion | SingleSelectQuestion | TextAreaQuestion | TextQuestion;

export type GreenhouseDataInput = {
  answers: Array<GreenhouseAnswerInput>;
  demographicAnswers: Array<GreenhouseDemographicAnswerInput>;
};

export type GreenhouseDemographicAnswer = GreenhouseDemographicMultiSelectAnswer | GreenhouseDemographicSingleSelectAnswer;

export type GreenhouseDemographicAnswerInput = {
  multiSelectAnswer?: InputMaybe<GreenhouseDemographicMultiSelectAnswerInput>;
  singleSelectAnswer?: InputMaybe<GreenhouseDemographicSingleSelectAnswerInput>;
};

export type GreenhouseDemographicChoice = {
  __typename: 'GreenhouseDemographicChoice';
  label: Scalars['String'];
  type: Maybe<GreenhouseDemographicChoiceType>;
  value: Scalars['String'];
};

export type GreenhouseDemographicChoiceInput = {
  label: Scalars['String'];
  type?: InputMaybe<GreenhouseDemographicChoiceType>;
  value: Scalars['String'];
};

export enum GreenhouseDemographicChoiceType {
  DeclineToAnswer = 'DECLINE_TO_ANSWER',
  FreeForm = 'FREE_FORM'
}

export type GreenhouseDemographicMultiSelectAnswer = {
  __typename: 'GreenhouseDemographicMultiSelectAnswer';
  choices: Array<GreenhouseDemographicChoice>;
  questionData: AnswerQuestionData;
};

export type GreenhouseDemographicMultiSelectAnswerInput = {
  choices: Array<GreenhouseDemographicChoiceInput>;
  questionData: QuestionDataInput;
};

export type GreenhouseDemographicMultiSelectQuestion = {
  __typename: 'GreenhouseDemographicMultiSelectQuestion';
  atsId: Scalars['String'];
  choices: Array<GreenhouseDemographicChoice>;
  question: Scalars['String'];
  required: Maybe<Scalars['Boolean']>;
};

export type GreenhouseDemographicQuestion = GreenhouseDemographicMultiSelectQuestion | GreenhouseDemographicSingleSelectQuestion;

export type GreenhouseDemographicQuestionSet = {
  __typename: 'GreenhouseDemographicQuestionSet';
  description: Scalars['String'];
  header: Scalars['String'];
  questions: Array<GreenhouseDemographicQuestion>;
};

export type GreenhouseDemographicSingleSelectAnswer = {
  __typename: 'GreenhouseDemographicSingleSelectAnswer';
  choice: GreenhouseDemographicChoice;
  questionData: AnswerQuestionData;
};

export type GreenhouseDemographicSingleSelectAnswerInput = {
  choice: GreenhouseDemographicChoiceInput;
  questionData: QuestionDataInput;
};

export type GreenhouseDemographicSingleSelectQuestion = {
  __typename: 'GreenhouseDemographicSingleSelectQuestion';
  atsId: Scalars['String'];
  choices: Array<GreenhouseDemographicChoice>;
  question: Scalars['String'];
  required: Maybe<Scalars['Boolean']>;
};

export type GreenhouseQuestionData = {
  __typename: 'GreenhouseQuestionData';
  demographicQuestionSet: Maybe<GreenhouseDemographicQuestionSet>;
  questions: Array<GreenhouseApplicationQuestion>;
};

/** The grouped workflow status of company jobs */
export enum GroupWorkflowStatus {
  /** Jobs which are either live or dead. */
  All = 'ALL',
  /** Jobs which are no longer active. */
  Dead = 'DEAD',
  /** Jobs which are completed and active. */
  Live = 'LIVE',
  /** Jobs which are dead but have been seen in the past 3 months */
  RecentDead = 'RECENT_DEAD'
}

export type HiddenCompany = {
  __typename: 'HiddenCompany';
  id: Scalars['ID'];
  logoPath: Maybe<Scalars['String']>;
  name: Scalars['String'];
};


export type HiddenCompanyLogoPathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};

export type HiddenCompanyInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Target category for an image upload */
export enum ImageCategory {
  CandidateCompanyLogo = 'CANDIDATE_COMPANY_LOGO',
  Favicon = 'FAVICON',
  Logo = 'LOGO',
  Photo = 'PHOTO'
}

export type ImportedCandidate = {
  __typename: 'ImportedCandidate';
  attachmentUrl: Maybe<Scalars['String']>;
  currentEmployer: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  externalId: Scalars['String'];
  firstName: Scalars['String'];
  importingCompanyId: Scalars['ID'];
  importingCompanyRecruiterId: Scalars['ID'];
  importingRecruiterName: Scalars['String'];
  insertedAt: Scalars['NaiveDateTime'];
  lastName: Scalars['String'];
  phoneNumber: Maybe<Scalars['String']>;
  portfolioUrl: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
  sourcedUrl: Maybe<Scalars['String']>;
};

export type ImportedCandidateInput = {
  attachmentUrl?: InputMaybe<Scalars['String']>;
  currentEmployer?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  jobId: Scalars['ID'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  pipelineStageId: Scalars['ID'];
  portfolioUrl?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourcedUrl?: InputMaybe<Scalars['String']>;
};

export type IntegerValue = {
  __typename: 'IntegerValue';
  value: Scalars['Int'];
};

export type InterviewExperience = {
  __typename: 'InterviewExperience';
  percentNegative: Scalars['Int'];
  percentPositive: Scalars['Int'];
};

/** Input options for interview feedback received */
export enum InterviewFeedbackReceived {
  No = 'NO',
  NoResponseYet = 'NO_RESPONSE_YET',
  Yes = 'YES'
}

export type Investor = {
  __typename: 'Investor';
  id: Scalars['ID'];
  topInvestor: Maybe<Scalars['Boolean']>;
  value: Maybe<Scalars['String']>;
};

export type InvestorInput = {
  topInvestor?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type InvestorPreferenceInput = {
  id: Scalars['ID'];
  preference?: InputMaybe<Scalars['Boolean']>;
};

export type Job = {
  __typename: 'Job';
  acceptsInternalApplications: Scalars['Boolean'];
  activelyHiring: Scalars['Boolean'];
  actualOriginalUrl: Maybe<Scalars['String']>;
  applicationProcessBullets: Array<JobApplicationProcessBullet>;
  applicationQuestions: Array<JobApplicationQuestion>;
  applicationStageStatistics: Maybe<JobApplicationStageStatistics>;
  applied: Maybe<Scalars['Boolean']>;
  appliedDateTime: Maybe<Scalars['DateTime']>;
  broadcasts: Array<JobBroadcast>;
  canBroadcast: Scalars['Boolean'];
  canChangeSalary: Scalars['Boolean'];
  candidates: Array<Candidate>;
  changes: Array<JobChange>;
  company: Company;
  daysSincePosted: Scalars['Int'];
  editedTitle: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  firstLiveAt: Maybe<Scalars['NaiveDateTime']>;
  function: Maybe<JobFunction>;
  hideSalary: Scalars['Boolean'];
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  internship: Maybe<Scalars['Boolean']>;
  involvesBullets: Array<JobInvolvesBullet>;
  isEligibleForOttaPro: Scalars['Boolean'];
  isPro: Scalars['Boolean'];
  languageRequirements: Array<JobLanguageRequirement>;
  lastSeen: Maybe<Scalars['DateTime']>;
  lastWorkflowStatusChangeBy: Maybe<User>;
  latestReaction: Maybe<JobReaction>;
  live: Scalars['Boolean'];
  locationInformation: Maybe<Scalars['String']>;
  locationPreferences: Array<LocationPreference>;
  locationRestrictions: Maybe<Scalars['String']>;
  lockedForProcessingAt: Maybe<Scalars['DateTime']>;
  maxDaysInOffice: Maybe<Scalars['Int']>;
  maxYearsExperienceRequired: Maybe<Scalars['Int']>;
  meetsMinSalaryPreference: Scalars['Boolean'];
  /** @deprecated Use message_response_statistics field instead */
  messageAcceptanceRate: Maybe<Scalars['Decimal']>;
  /** @deprecated Use message_response_statistics field instead */
  messageNoResponseRate: Maybe<Scalars['Decimal']>;
  /** @deprecated Use message_response_statistics field instead */
  messageRejectionRate: Maybe<Scalars['Decimal']>;
  messageResponseRateStatistics: JobMessageResponseRateStatistics;
  minDaysInOffice: Maybe<Scalars['Int']>;
  minYearsExperienceRequired: Maybe<Scalars['Int']>;
  numberBroadcastRecipients: Scalars['Int'];
  numberBroadcastableCandidates: Scalars['Int'];
  numberCandidatesApplied: Maybe<Scalars['Int']>;
  numberCandidatesDiscarded: Maybe<Scalars['Int']>;
  numberCandidatesMessaged: Maybe<Scalars['Int']>;
  numberCandidatesQualified: Maybe<Scalars['Int']>;
  numberCandidatesRemaining: Maybe<Scalars['Int']>;
  numberCandidatesReplied: Maybe<Scalars['Int']>;
  numberCandidatesShortlisted: Maybe<Scalars['Int']>;
  numberUnreadMessages: Maybe<Scalars['Int']>;
  officeLocation: Maybe<Scalars['String']>;
  originalUrl: Maybe<Scalars['String']>;
  oteSalaryRange: Maybe<MoneyRange>;
  otherCompensationInformation: Maybe<Scalars['String']>;
  personalisedCandidates: PersonalisedCandidatesResult;
  /** @deprecated Deprecated in favour of is_pro */
  proTier: Scalars['Boolean'];
  questionData: JobQuestionData;
  remoteOnly: Scalars['Boolean'];
  requirements: Array<JobRequirement>;
  salaryRange: Maybe<MoneyRange>;
  scrapedExperienceLevel: Maybe<Scalars['String']>;
  scrapedExperienceText: Maybe<Scalars['String']>;
  scrapedLocation: Maybe<Scalars['String']>;
  subFunction: Maybe<JobSubFunction>;
  subtitle: Maybe<Scalars['String']>;
  technologiesUsed: Array<JobTechnologyUsed>;
  title: Scalars['String'];
  /** @deprecated Deprecated in favour of user_job_status_info */
  userJobStatus: UserJobStatus;
  userJobStatusInfo: UserJobStatusInfo;
  /** @deprecated Deprecated in favour of user_job_status_info */
  userJobStatusUpdatedAt: Maybe<Scalars['DateTime']>;
  validUntil: Scalars['NaiveDateTime'];
  workflowNotes: Maybe<Scalars['String']>;
  workflowStatus: JobWorkflowStatus;
};


export type JobApplicationStageStatisticsArgs = {
  applicationStage: JobApplicationStage;
};


export type JobCandidatesArgs = {
  candidateStatus?: InputMaybe<CandidateStatus>;
  status?: InputMaybe<Scalars['String']>;
};


export type JobMessageAcceptanceRateArgs = {
  timePeriod?: InputMaybe<Scalars['DateTime']>;
};


export type JobMessageNoResponseRateArgs = {
  timePeriod?: InputMaybe<Scalars['DateTime']>;
};


export type JobMessageRejectionRateArgs = {
  timePeriod?: InputMaybe<Scalars['DateTime']>;
};


export type JobMessageResponseRateStatisticsArgs = {
  timePeriod?: InputMaybe<Scalars['DateTime']>;
};


export type JobNumberCandidatesAppliedArgs = {
  excludeQualified?: InputMaybe<Scalars['Boolean']>;
  excludeRejected?: InputMaybe<Scalars['Boolean']>;
};


export type JobNumberCandidatesMessagedArgs = {
  excludeQualified?: InputMaybe<Scalars['Boolean']>;
  excludeRejected?: InputMaybe<Scalars['Boolean']>;
  timePeriod?: InputMaybe<Scalars['DateTime']>;
};


export type JobNumberCandidatesRemainingArgs = {
  filters?: InputMaybe<PersonalisedCandidateFilters>;
};


export type JobNumberCandidatesRepliedArgs = {
  excludeQualified?: InputMaybe<Scalars['Boolean']>;
  excludeRejected?: InputMaybe<Scalars['Boolean']>;
  timePeriod?: InputMaybe<Scalars['DateTime']>;
};


export type JobNumberCandidatesShortlistedArgs = {
  includeInactiveCandidates?: InputMaybe<Scalars['Boolean']>;
  timePeriod?: InputMaybe<Scalars['DateTime']>;
};


export type JobNumberUnreadMessagesArgs = {
  conversationStage?: InputMaybe<ConversationStage>;
  excludeQualified?: InputMaybe<Scalars['Boolean']>;
};


export type JobPersonalisedCandidatesArgs = {
  preferences?: InputMaybe<PersonalisedCandidatesPreferences>;
};

export type JobApplication = {
  __typename: 'JobApplication';
  accepted: Maybe<Scalars['Boolean']>;
  applied: Scalars['Boolean'];
  appliedAt: Maybe<Scalars['DateTime']>;
  candidate: Candidate;
  clicked: Scalars['Boolean'];
  conversation: Maybe<CandidateConversation>;
  data: Maybe<JobApplicationData>;
  externalId: Scalars['ID'];
  externalResponded: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internal: Scalars['Boolean'];
  job: Job;
  lastActionAt: Scalars['NaiveDateTime'];
  questionResponses: Array<JobApplicationQuestionResponse>;
};

export type JobApplicationData = {
  __typename: 'JobApplicationData';
  data: AtsAnswerData;
  id: Scalars['ID'];
};

export type JobApplicationDataInput = {
  greenhouseData?: InputMaybe<GreenhouseDataInput>;
  leverData?: InputMaybe<LeverDataInput>;
  ottaData?: InputMaybe<OttaDataInput>;
  workableData?: InputMaybe<WorkableDataInput>;
};

export type JobApplicationInput = {
  applied?: InputMaybe<Scalars['Boolean']>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  lastConfirmedAt?: InputMaybe<Scalars['NaiveDateTime']>;
};

export type JobApplicationProcessBullet = {
  __typename: 'JobApplicationProcessBullet';
  id: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type JobApplicationProcessBulletInput = {
  externalId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type JobApplicationQuestion = {
  __typename: 'JobApplicationQuestion';
  atsId: Scalars['String'];
  choices: Maybe<Array<JobApplicationQuestionChoice>>;
  id: Scalars['ID'];
  job: Job;
  prompt: Maybe<Scalars['String']>;
  required: Maybe<Scalars['Boolean']>;
  type: JobApplicationQuestionType;
  value: Scalars['String'];
};

export type JobApplicationQuestionChoice = {
  __typename: 'JobApplicationQuestionChoice';
  id: Scalars['ID'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type JobApplicationQuestionResponse = {
  __typename: 'JobApplicationQuestionResponse';
  data: QuestionResponseData;
  id: Scalars['ID'];
  question: Scalars['String'];
};

export enum JobApplicationQuestionType {
  Boolean = 'BOOLEAN',
  Checkboxes = 'CHECKBOXES',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  File = 'FILE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Numeric = 'NUMERIC',
  Text = 'TEXT',
  TextArea = 'TEXT_AREA',
  University = 'UNIVERSITY',
  Url = 'URL'
}

/** The possible options for a job application stage */
export enum JobApplicationStage {
  /** When users have sent off an application. */
  Applied = 'APPLIED',
  /** When users have clicked to apply to a job. */
  ClickedApply = 'CLICKED_APPLY',
  /** When the job has been saved by users. */
  Saved = 'SAVED',
  /** When the job has been viewed by users. */
  Viewed = 'VIEWED'
}

export type JobApplicationStageStatistics = {
  __typename: 'JobApplicationStageStatistics';
  averageTimeSpentInSeconds: Maybe<Scalars['Decimal']>;
  conversionRate: Scalars['Decimal'];
  conversionRateBenchmark: Maybe<Scalars['Decimal']>;
  femalePercentage: Maybe<Scalars['Decimal']>;
  malePercentage: Maybe<Scalars['Decimal']>;
  nonBinaryPercentage: Maybe<Scalars['Decimal']>;
  numberCandidates: Scalars['Int'];
  transgenderPercentage: Maybe<Scalars['Decimal']>;
};

export type JobBroadcast = {
  __typename: 'JobBroadcast';
  companyRecruiter: User;
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  message: Scalars['String'];
  numberBroadcastedTo: Scalars['Int'];
};

export type JobChange = {
  __typename: 'JobChange';
  changedBy: JobChanger;
  dismissedAt: Maybe<Scalars['DateTime']>;
  fieldName: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  newValue: Maybe<JobChangeValue>;
  oldValue: Maybe<JobChangeValue>;
  user: Maybe<User>;
};

export type JobChangeValue = BooleanValue | DatetimeValue | DecimalValue | IntegerValue | StringListValue | StringValue;

export enum JobChanger {
  Heuristics = 'HEURISTICS',
  MachineLearning = 'MACHINE_LEARNING',
  Scraper = 'SCRAPER',
  User = 'USER'
}

export type JobExperiencePreference = {
  __typename: 'JobExperiencePreference';
  entryLevel: Scalars['Boolean'];
  fiveToEightYears: Scalars['Boolean'];
  internship: Scalars['Boolean'];
  ninePlusYears: Scalars['Boolean'];
  oneToTwoYears: Scalars['Boolean'];
  showManagementRoles: Scalars['Boolean'];
  threeToFourYears: Scalars['Boolean'];
};

export type JobExperiencePreferenceInput = {
  entryLevel?: InputMaybe<Scalars['Boolean']>;
  fiveToEightYears?: InputMaybe<Scalars['Boolean']>;
  internship?: InputMaybe<Scalars['Boolean']>;
  ninePlusYears?: InputMaybe<Scalars['Boolean']>;
  oneToTwoYears?: InputMaybe<Scalars['Boolean']>;
  showManagementRoles?: InputMaybe<Scalars['Boolean']>;
  threeToFourYears?: InputMaybe<Scalars['Boolean']>;
};

export type JobFunction = {
  __typename: 'JobFunction';
  id: Scalars['ID'];
  subFunctions: Array<JobSubFunction>;
  value: Scalars['String'];
};

export type JobFunctionPreference = {
  __typename: 'JobFunctionPreference';
  functionId: Scalars['ID'];
};

export type JobFunctionPreferenceInput = {
  functionId: Scalars['ID'];
};

export type JobInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  editedTitle?: InputMaybe<Scalars['String']>;
  hideSalary?: InputMaybe<Scalars['Boolean']>;
  internship?: InputMaybe<Scalars['Boolean']>;
  lastSeen?: InputMaybe<Scalars['DateTime']>;
  locationInformation?: InputMaybe<Scalars['String']>;
  locationPreferences?: InputMaybe<Array<LocationPreferenceInput>>;
  locationRestrictions?: InputMaybe<Scalars['String']>;
  maxDaysInOffice?: InputMaybe<Scalars['Int']>;
  maxYearsExperienceRequired?: InputMaybe<Scalars['Int']>;
  minDaysInOffice?: InputMaybe<Scalars['Int']>;
  minYearsExperienceRequired?: InputMaybe<Scalars['Int']>;
  officeLocation?: InputMaybe<Scalars['String']>;
  oteSalaryRange?: InputMaybe<MoneyRangeInput>;
  otherCompensationInformation?: InputMaybe<Scalars['String']>;
  salaryRange?: InputMaybe<MoneyRangeInput>;
  subtitle?: InputMaybe<Scalars['String']>;
  workflowNotes?: InputMaybe<Scalars['String']>;
};

export type JobInteractionStatistics = {
  __typename: 'JobInteractionStatistics';
  numberJobsApplied: Scalars['Int'];
  numberJobsSaved: Scalars['Int'];
  numberJobsSeen: Scalars['Int'];
};

export type JobInterview = {
  __typename: 'JobInterview';
  candidateFeedback: Maybe<JobInterviewCandidateFeedback>;
  feedbackReceived: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  job: Job;
  user: User;
};

export type JobInterviewCandidateFeedback = {
  __typename: 'JobInterviewCandidateFeedback';
  id: Scalars['ID'];
  jobInterview: JobInterview;
  netPromoterScore: Maybe<Scalars['Int']>;
  privateMessage: Maybe<Scalars['String']>;
};

export type JobInterviewCandidateFeedbackInput = {
  netPromoterScore?: InputMaybe<Scalars['Int']>;
  privateMessage?: InputMaybe<Scalars['String']>;
};

export type JobInvolvesBullet = {
  __typename: 'JobInvolvesBullet';
  id: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type JobInvolvesBulletInput = {
  externalId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type JobLanguageRequirement = {
  __typename: 'JobLanguageRequirement';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type JobLanguageRequirementInput = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type JobMessageResponseRateStatistics = {
  __typename: 'JobMessageResponseRateStatistics';
  acceptanceRate: Maybe<Scalars['Decimal']>;
  noResponseRate: Maybe<Scalars['Decimal']>;
  rejectionRate: Maybe<Scalars['Decimal']>;
};

export type JobOffer = {
  __typename: 'JobOffer';
  accepted: Maybe<Scalars['Boolean']>;
  acceptedAt: Maybe<Scalars['DateTime']>;
  creationMethod: Maybe<CreationMethod>;
  deleted: Maybe<Scalars['Boolean']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  job: Job;
  pendingUntil: Maybe<Scalars['DateTime']>;
  sentHiredEmail: Scalars['Boolean'];
  user: User;
};

export type JobOfferInput = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
};

export type JobPipeline = {
  __typename: 'JobPipeline';
  candidatePipelineStages: Maybe<Array<CandidatePipelineStage>>;
  jobId: Scalars['ID'];
};

export type JobPreferenceSuggestion = {
  id: Scalars['ID'];
};

export type JobProblem = {
  __typename: 'JobProblem';
  content: Scalars['String'];
  id: Scalars['ID'];
};

export type JobQuestionData = {
  __typename: 'JobQuestionData';
  data: AtsQuestionData;
};

export type JobReaction = {
  __typename: 'JobReaction';
  direction: Scalars['Boolean'];
  id: Scalars['ID'];
  job: Job;
  reason: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Scalars['NaiveDateTime'];
  user: User;
};

export type JobReactionStatistics = {
  __typename: 'JobReactionStatistics';
  numberJobsSaved: Scalars['Int'];
  numberJobsSeen: Scalars['Int'];
};

export type JobRecommendation = {
  __typename: 'JobRecommendation';
  id: Scalars['ID'];
  job: Job;
};

export type JobRequirement = {
  __typename: 'JobRequirement';
  desirable: Scalars['Boolean'];
  id: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

export type JobRequirementInput = {
  desirable?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['ID'];
};

export type JobSubFunction = {
  __typename: 'JobSubFunction';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type JobSubFunctionPreference = {
  __typename: 'JobSubFunctionPreference';
  subFunctionId: Scalars['ID'];
};

export type JobSubFunctionPreferenceInput = {
  subFunctionId: Scalars['ID'];
};

export type JobTechnologyUsed = {
  __typename: 'JobTechnologyUsed';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type JobTechnologyUsedInput = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type JobWithStatistics = {
  __typename: 'JobWithStatistics';
  company: Maybe<PublicCompany>;
  externalId: Scalars['String'];
  function: Maybe<JobFunction>;
  id: Scalars['ID'];
  locationPreferences: Array<LocationPreference>;
  numberReactions: Scalars['Int'];
  percentageApplied: Scalars['Int'];
  percentageSaved: Scalars['Int'];
  similarJobs: Array<JobWithStatistics>;
  subFunction: Maybe<JobSubFunction>;
  subtitle: Maybe<Scalars['String']>;
  technologiesUsed: Array<JobTechnologyUsed>;
  title: Scalars['String'];
};

/** The workflow status of a job */
export enum JobWorkflowStatus {
  /** A job which has been marked as no longer active, and therefore unavailable to view. */
  Archived = 'ARCHIVED',
  /** A job which has changed and requires review. */
  Changed = 'CHANGED',
  /** A completed job which can be shown on the platform. */
  Completed = 'COMPLETED',
  /** A job which was disapproved from being on the platform. */
  Disapproved = 'DISAPPROVED',
  /** A job marked as an exception externally, requiring internal review. */
  Exception = 'EXCEPTION',
  /** A job which has a last seen deemed too long ago, and has thus been automatically moved to this state */
  Inactive = 'INACTIVE',
  /** A job which has either the qa_internal or changed status. */
  Pending = 'PENDING',
  /** A new job which has not been approved yet. */
  PreApproval = 'PRE_APPROVAL',
  /** A job which has been completed and requires external quality assurance. */
  QaExternal = 'QA_EXTERNAL',
  /** A job which has been completed and requires internal quality assurance. */
  QaInternal = 'QA_INTERNAL',
  /** A job which has been queued for completion externally. */
  QueuedExternal = 'QUEUED_EXTERNAL',
  /** A job which has been queued for completion internally. */
  QueuedInternal = 'QUEUED_INTERNAL',
  /** A job which has been created by a company recruiter but not yet submitted for approval. */
  RecruiterDraft = 'RECRUITER_DRAFT'
}

export type JobsWithSalaryStats = {
  __typename: 'JobsWithSalaryStats';
  numberLiveJobs: Scalars['Int'];
  numberLiveJobsWithPublicSalary: Scalars['Int'];
  numberLiveJobsWithSalary: Scalars['Int'];
};

export type LanguageRequirementPreference = {
  __typename: 'LanguageRequirementPreference';
  /** @deprecated Use language requirement id instead */
  id: Scalars['ID'];
  languageRequirementId: Scalars['ID'];
};

export type LanguageRequirementPreferenceInput = {
  id?: InputMaybe<Scalars['ID']>;
  languageRequirementId?: InputMaybe<Scalars['ID']>;
};

export type LeverAnswer = FileAnswer | MultiSelectAnswer | SingleSelectAnswer | TextAnswer | TextAreaAnswer | UrlAnswer;

export type LeverAnswerData = {
  __typename: 'LeverAnswerData';
  answers: Array<LeverAnswer>;
};

export type LeverAnswerInput = {
  existingFileAnswer?: InputMaybe<ExistingFileAnswerInput>;
  fileAnswer?: InputMaybe<NewFileAnswerInput>;
  multiSelectAnswer?: InputMaybe<MultiSelectAnswerInput>;
  singleSelectAnswer?: InputMaybe<SingleSelectAnswerInput>;
  textAnswer?: InputMaybe<TextAnswerInput>;
  textAreaAnswer?: InputMaybe<TextAreaAnswerInput>;
  urlAnswer?: InputMaybe<UrlAnswerInput>;
};

export type LeverApplicationQuestion = FileQuestion | MultiSelectQuestion | SingleSelectQuestion | TextAreaQuestion | TextQuestion | UrlQuestion;

export type LeverDataInput = {
  answers: Array<LeverAnswerInput>;
};

export type LeverQuestionData = {
  __typename: 'LeverQuestionData';
  questions: Array<LeverApplicationQuestion>;
};

/** Locations available as preferences */
export enum Location {
  Amsterdam = 'AMSTERDAM',
  AustinUs = 'AUSTIN_US',
  Barcelona = 'BARCELONA',
  Berlin = 'BERLIN',
  BostonUs = 'BOSTON_US',
  ChicagoUs = 'CHICAGO_US',
  DenverUs = 'DENVER_US',
  Dublin = 'DUBLIN',
  London = 'LONDON',
  LosAngelesUs = 'LOS_ANGELES_US',
  MiamiUs = 'MIAMI_US',
  NewYorkUs = 'NEW_YORK_US',
  Paris = 'PARIS',
  RemoteCanada = 'REMOTE_CANADA',
  RemoteEurope = 'REMOTE_EUROPE',
  RemoteFrance = 'REMOTE_FRANCE',
  RemoteGermany = 'REMOTE_GERMANY',
  RemoteIreland = 'REMOTE_IRELAND',
  RemoteNetherlands = 'REMOTE_NETHERLANDS',
  RemoteSpain = 'REMOTE_SPAIN',
  RemoteUk = 'REMOTE_UK',
  RemoteUs = 'REMOTE_US',
  SanFranciscoBayAreaUs = 'SAN_FRANCISCO_BAY_AREA_US',
  Toronto = 'TORONTO',
  Vancouver = 'VANCOUVER'
}

export type LocationPreference = {
  __typename: 'LocationPreference';
  id: Scalars['ID'];
  location: Location;
};

export type LocationPreferenceInput = {
  location: Location;
};

export type MessageTemplate = {
  __typename: 'MessageTemplate';
  id: Scalars['ID'];
  message: Scalars['String'];
  name: Scalars['String'];
  showToAll: Scalars['Boolean'];
  type: MessageTemplateTypeEnum;
};

/** The possible options for message template type */
export enum MessageTemplateTypeEnum {
  Rejection = 'REJECTION',
  Sourcing = 'SOURCING'
}

export type Money = {
  __typename: 'Money';
  amount: Scalars['Decimal'];
  currency: Currency;
};

export type MoneyInput = {
  amount: Scalars['Decimal'];
  currency: Currency;
};

export type MoneyRange = {
  __typename: 'MoneyRange';
  currency: Currency;
  maxAmount: Maybe<Scalars['Decimal']>;
  minAmount: Maybe<Scalars['Decimal']>;
};

export type MoneyRangeInput = {
  currency: Currency;
  maxAmount?: InputMaybe<Scalars['Decimal']>;
  minAmount?: InputMaybe<Scalars['Decimal']>;
};

export type MultiSelectAnswer = {
  __typename: 'MultiSelectAnswer';
  choices: Array<Choice>;
  questionData: AnswerQuestionData;
};

export type MultiSelectAnswerInput = {
  choices: Array<ChoiceInput>;
  questionData: QuestionDataInput;
};

export type MultiSelectQuestion = {
  __typename: 'MultiSelectQuestion';
  atsId: Maybe<Scalars['String']>;
  choices: Array<Choice>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type MultipleChoiceResponse = {
  __typename: 'MultipleChoiceResponse';
  choices: Array<SingleChoiceResponse>;
};

export type NewFileAnswerInput = {
  file: Scalars['Upload'];
  name: Scalars['String'];
  questionData: QuestionDataInput;
};

export type NewUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  marketingConsent?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  referredByUserId?: InputMaybe<Scalars['ID']>;
  utmSource?: InputMaybe<Scalars['String']>;
};

/** Available notifications */
export enum Notification {
  BatchEndResubscribe = 'BATCH_END_RESUBSCRIBE',
  CanadaJobs = 'CANADA_JOBS',
  CompleteProfile = 'COMPLETE_PROFILE',
  CreateProfile = 'CREATE_PROFILE',
  FullProfile = 'FULL_PROFILE',
  HiddenProfile = 'HIDDEN_PROFILE',
  NeedEuVisa = 'NEED_EU_VISA',
  ProfilePerformance = 'PROFILE_PERFORMANCE',
  UnhideProfile = 'UNHIDE_PROFILE'
}

/** Frequencies at which it is possible to receive notifications */
export enum NotificationFrequency {
  Daily = 'DAILY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

/** The possible options for opt in status */
export enum OptInStatusEnum {
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT'
}

export type OttaAnswer = TextAreaAnswer;

export type OttaAnswerData = {
  __typename: 'OttaAnswerData';
  answers: Array<OttaAnswer>;
};

export type OttaAnswerInput = {
  textAreaAnswer?: InputMaybe<TextAreaAnswerInput>;
};

export type OttaApplicationQuestion = TextAreaQuestion;

export type OttaDataInput = {
  answers: Array<OttaAnswerInput>;
};

export type OttaQuestionData = {
  __typename: 'OttaQuestionData';
  questions: Array<OttaApplicationQuestion>;
};

/** Available permissions */
export enum Permission {
  CompanyAdmin = 'COMPANY_ADMIN',
  ManageChangedCompanies = 'MANAGE_CHANGED_COMPANIES',
  ManageCompanyEndorsements = 'MANAGE_COMPANY_ENDORSEMENTS',
  ManageExceptionJobs = 'MANAGE_EXCEPTION_JOBS',
  ManageJobSalaries = 'MANAGE_JOB_SALARIES',
  ManagePreApprovalJobs = 'MANAGE_PRE_APPROVAL_JOBS',
  ManageQaInternalJobs = 'MANAGE_QA_INTERNAL_JOBS',
  ViewSalary = 'VIEW_SALARY'
}

export type PermissionObject = {
  __typename: 'PermissionObject';
  description: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Permission;
  scope: PermissionScope;
};

export enum PermissionScope {
  Hire = 'HIRE',
  Search = 'SEARCH',
  Toolbox = 'TOOLBOX'
}

export type PersonalisedCandidateFilters = {
  completedProfile?: InputMaybe<Scalars['Boolean']>;
  ethnicities?: InputMaybe<Array<EthnicityEnum>>;
  experienceRange?: InputMaybe<ExperienceRange>;
  genders?: InputMaybe<Array<Gender>>;
  jobFunctions?: InputMaybe<Array<Scalars['ID']>>;
  jobSubFunctions?: InputMaybe<Array<Scalars['ID']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']>>;
  maxSalary?: InputMaybe<MoneyInput>;
  recentlyActive?: InputMaybe<Scalars['Boolean']>;
  regions?: InputMaybe<Array<Scalars['String']>>;
  savedCompany?: InputMaybe<Scalars['Boolean']>;
  savedJob?: InputMaybe<Scalars['Boolean']>;
  searchStages?: InputMaybe<Array<Scalars['String']>>;
  subRegions?: InputMaybe<Array<Scalars['String']>>;
  visaSponsorshipCountries?: InputMaybe<Array<VisaSponsorshipCountryInput>>;
  workExperienceCompanies?: InputMaybe<Array<Scalars['String']>>;
  workExperienceTechnologies?: InputMaybe<Array<Scalars['ID']>>;
};

export type PersonalisedCandidatesPreferences = {
  companyNames?: InputMaybe<Array<Scalars['String']>>;
  completedProfile?: InputMaybe<Scalars['Boolean']>;
  ethnicities?: InputMaybe<Array<EthnicityEnum>>;
  experienceRange?: InputMaybe<ExperienceRange>;
  genders?: InputMaybe<Array<Gender>>;
  jobSubFunctionIds?: InputMaybe<Array<Scalars['ID']>>;
  keywords?: InputMaybe<Array<Scalars['String']>>;
  maxSalary?: InputMaybe<MoneyInput>;
  mustIncludeAllKeywords?: InputMaybe<Scalars['Boolean']>;
  recentlyActive?: InputMaybe<Scalars['Boolean']>;
  regions?: InputMaybe<Array<Scalars['String']>>;
  savedCompany?: InputMaybe<Scalars['Boolean']>;
  savedJob?: InputMaybe<Scalars['Boolean']>;
  subregions?: InputMaybe<Array<Scalars['String']>>;
  visaSponsorshipRegions?: InputMaybe<Array<VisaRegion>>;
};

export type PersonalisedCandidatesResult = {
  __typename: 'PersonalisedCandidatesResult';
  candidates: Array<Candidate>;
  total: Scalars['Int'];
};

export type Photo = {
  __typename: 'Photo';
  id: Scalars['ID'];
  path: Scalars['String'];
};


export type PhotoPathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};

export type PhotoInput = {
  path: Scalars['String'];
};

export type PipelineCandidate = {
  __typename: 'PipelineCandidate';
  activated: Scalars['Boolean'];
  atsProfileUrl: Maybe<Scalars['String']>;
  averageResponseTime: Maybe<Scalars['Int']>;
  companyQualitiesPreferences: Array<CompanyQualitiesPreference>;
  companySizePreferences: Array<CompanySizePreference>;
  companySubQualitiesPreferences: Array<CompanySubQualitiesPreference>;
  contextQuestionResponses: Array<CandidateContextQuestionResponse>;
  currentCompany: Maybe<Company>;
  currentTitle: Maybe<Scalars['String']>;
  discardedJobs: Array<Job>;
  discardedSubFunctions: Array<JobSubFunction>;
  diverse: Scalars['Boolean'];
  diversityMatch: Scalars['Boolean'];
  educationExperiences: Array<UserEducationExperience>;
  email: Scalars['String'];
  ethnicities: Array<Ethnicity>;
  externalId: Scalars['ID'];
  firstName: Scalars['String'];
  genders: Array<Gender>;
  hasSetPreferences: Maybe<Scalars['Boolean']>;
  hasSubmittedSalary: Scalars['Boolean'];
  hiddenCompanies: Array<HiddenCompany>;
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  /** @deprecated Use job_applications instead */
  internalJobApplications: Array<JobApplication>;
  jobApplications: Array<JobApplication>;
  jobEmailNotificationsFrequency: NotificationFrequency;
  jobExperiencePreference: Maybe<JobExperiencePreference>;
  /** @deprecated Renamed to job_experience_preference */
  jobExperiencePreferences: Maybe<UserJobExperiencePreferences>;
  jobFunctionPreferences: Array<JobFunctionPreference>;
  /** @deprecated Unused - see job reaction statistics */
  jobInteractionStatistics: JobInteractionStatistics;
  jobNotificationUnsubscription: Scalars['Boolean'];
  jobPreferenceSuggestions: Maybe<Array<JobPreferenceSuggestion>>;
  jobReactionStatistics: JobReactionStatistics;
  jobRecommendations: Array<JobRecommendation>;
  jobSubFunctionPreferences: Array<JobSubFunctionPreference>;
  jobsProcessed: Maybe<Scalars['Int']>;
  languageRequirementPreferences: Array<LanguageRequirementPreference>;
  lastActive: Scalars['NaiveDateTime'];
  lastName: Scalars['String'];
  lastUnconfirmedJobApplication: Maybe<Scalars['String']>;
  linkedinUrl: Maybe<Scalars['String']>;
  locationPreferences: Array<LocationPreference>;
  marketingConsent: Scalars['Boolean'];
  messageRequestsSentFromCompany: Array<CandidateMessageRequest>;
  /** @deprecated Use min_salary_requirement instead */
  minSalaryPreference: Maybe<Scalars['Int']>;
  minSalaryRequirement: Maybe<Money>;
  mostRecentJobInterview: Maybe<CandidateJobInterview>;
  numReferrals: Maybe<Scalars['Int']>;
  numUnreadShortlistedJobs: Scalars['Int'];
  permissions: Array<PermissionObject>;
  phoneNumber: Maybe<Scalars['String']>;
  profileCompletion: Array<ProfileCompletionComponent>;
  profileImagePath: Maybe<Scalars['String']>;
  profileInterests: Maybe<Scalars['String']>;
  projects: Array<UserProject>;
  pronoun: Maybe<Pronoun>;
  receivedMessageRequests: Array<CandidateMessageRequest>;
  region: Maybe<Scalars['String']>;
  retained: Scalars['Boolean'];
  role: RoleType;
  savedJobsAtCompany: Array<PublicJob>;
  savedSimilarCompanies: Array<PublicCompany>;
  searchStage: Maybe<Scalars['String']>;
  sectorTagPreferences: Array<SectorTagPreference>;
  sexualOrientation: Maybe<SexualOrientation>;
  shortlisted: Scalars['Boolean'];
  shortlistedJobs: Array<Job>;
  showProfileToCompanies: Scalars['Boolean'];
  showRequestAdvice: Maybe<Scalars['Boolean']>;
  signUpReasonResponses: Array<SignUpReasonResponse>;
  signupRegion: Maybe<Scalars['String']>;
  signupSubregion: Maybe<Scalars['String']>;
  subregion: Maybe<Scalars['String']>;
  technologiesUsedPreferences: Array<TechnologyUsedPreference>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
  timezone: Maybe<Timezone>;
  /** @deprecated Deprecated */
  topCandidate: Scalars['Boolean'];
  totalDiscardedJobs: Maybe<Scalars['Int']>;
  totalJobApplicationClicks: Scalars['Int'];
  totalJobApplicationConfirms: Scalars['Int'];
  totalJobReactions: Scalars['Int'];
  totalRemainingJobs: Scalars['Int'];
  unreadMessages: Array<ConversationMessage>;
  verifiedEmail: Scalars['Boolean'];
  visaRequirementCountries: Array<VisaRequirementCountry>;
  websiteLinks: Array<WebsiteLink>;
  workExperience: Array<UserWorkExperience>;
  workExperiences: Array<UserWorkExperience>;
};


export type PipelineCandidateAtsProfileUrlArgs = {
  jobId: Scalars['ID'];
};


export type PipelineCandidateDiscardedJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PipelineCandidateDiversityMatchArgs = {
  filters?: InputMaybe<PersonalisedCandidateFilters>;
};


export type PipelineCandidateJobApplicationsArgs = {
  applied?: InputMaybe<Scalars['Boolean']>;
  appliedAtGt?: InputMaybe<Scalars['DateTime']>;
  appliedAtLt?: InputMaybe<Scalars['DateTime']>;
  externalOrSentToAts?: InputMaybe<Scalars['Boolean']>;
  externalResponded?: InputMaybe<Array<ExternalResponded>>;
  internal?: InputMaybe<Scalars['Boolean']>;
  orderByLeastResponseRateDatapoints?: InputMaybe<Scalars['Boolean']>;
  stillApplied?: InputMaybe<Scalars['Boolean']>;
};


export type PipelineCandidateJobInteractionStatisticsArgs = {
  since: Scalars['NaiveDateTime'];
};


export type PipelineCandidateJobRecommendationsArgs = {
  ignoreSubfunctions?: InputMaybe<Scalars['Boolean']>;
  preferredSectorId?: InputMaybe<Scalars['ID']>;
  sectorTagIds?: InputMaybe<Array<Scalars['Int']>>;
  themeId?: InputMaybe<ThemeId>;
};


export type PipelineCandidateJobsProcessedArgs = {
  since: Scalars['DateTime'];
};


export type PipelineCandidateProfileImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type PipelineCandidateShortlistedArgs = {
  jobId: Scalars['ID'];
};


export type PipelineCandidateTopCandidateArgs = {
  jobId: Scalars['ID'];
};


export type PipelineCandidateTotalRemainingJobsArgs = {
  ignoreSubfunctions?: InputMaybe<Scalars['Boolean']>;
  sectorTagIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type PipelineCandidateUnreadMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type PipelineCandidateWorkExperienceArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type Product = {
  __typename: 'Product';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ProductType {
  Basic = 'BASIC',
  Pro = 'PRO'
}

/** The components that contribute to profile completion */
export enum ProfileCompletionComponent {
  HasEducationExperience = 'HAS_EDUCATION_EXPERIENCE',
  HasInterests = 'HAS_INTERESTS',
  HasLinkedin = 'HAS_LINKEDIN',
  HasMoreAboutYou = 'HAS_MORE_ABOUT_YOU',
  HasSnippets = 'HAS_SNIPPETS',
  HasWorkExperience = 'HAS_WORK_EXPERIENCE',
  HasWorkExperienceDescriptions = 'HAS_WORK_EXPERIENCE_DESCRIPTIONS',
  HasWorkExperienceTechnologies = 'HAS_WORK_EXPERIENCE_TECHNOLOGIES'
}

/** The states of profile completion */
export enum ProfileState {
  /** Work experience (at least 1), 3 work experience descriptions (or less than 3 if does not have 3 work experiences), Technologies (Product/Data/Engineering/Design ONLY), (at least 1), Education (at least 1), linkedin URL */
  Deep = 'DEEP',
  /** Same as deep, plus Snippets (at least 1), Interests (at least 1), More about you (at least 1) */
  Full = 'FULL',
  /** No information has been added */
  NotCreated = 'NOT_CREATED',
  /** At least one field has been added */
  Partial = 'PARTIAL'
}

export type ProfileStatus = {
  __typename: 'ProfileStatus';
  completedFields: Maybe<Array<Maybe<Scalars['String']>>>;
  mostRecentSourcingViews: Array<Scalars['String']>;
  numSourcingViews: Scalars['Int'];
  percent: Maybe<Scalars['Int']>;
  state: Maybe<ProfileState>;
};

export type ProjectTechnologyUsedInput = {
  id: Scalars['ID'];
};

/** The possible options for user pronouns */
export enum Pronoun {
  HeHim = 'HE_HIM',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  SheHer = 'SHE_HER',
  TheyThem = 'THEY_THEM'
}

export type PublicCompany = {
  __typename: 'PublicCompany';
  domainName: Maybe<Scalars['String']>;
  faviconPath: Maybe<Scalars['String']>;
  glassdoorUrl: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoPath: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberHistoricalJobs: Scalars['Int'];
  numberLiveJobs: Scalars['Int'];
  scraperUrl: Maybe<Scalars['String']>;
  trustpilotUrl: Maybe<Scalars['String']>;
  urlSafeName: Scalars['String'];
  websiteUrl: Maybe<Scalars['String']>;
};


export type PublicCompanyFaviconPathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type PublicCompanyLogoPathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};

export type PublicCompanyRecruiter = {
  __typename: 'PublicCompanyRecruiter';
  currentTitle: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  profileImagePath: Maybe<Scalars['String']>;
};


export type PublicCompanyRecruiterProfileImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};

export type PublicJob = {
  __typename: 'PublicJob';
  externalId: Scalars['String'];
  function: Maybe<JobFunction>;
  id: Scalars['ID'];
  locationPreferences: Array<LocationPreference>;
  subFunction: Maybe<JobSubFunction>;
  subtitle: Maybe<Scalars['String']>;
  technologiesUsed: Array<JobTechnologyUsed>;
  title: Scalars['String'];
};

export type PublicJobApplication = {
  __typename: 'PublicJobApplication';
  candidate: Candidate;
  data: Maybe<JobApplicationData>;
  job: PublicJob;
  questionResponses: Array<JobApplicationQuestionResponse>;
};

export type PublicStatistics = {
  __typename: 'PublicStatistics';
  numberLiveCandidateProfiles: Scalars['Int'];
  numberLiveCompanies: Scalars['Int'];
  numberLiveJobs: Scalars['Int'];
  numberUsers: Scalars['Int'];
};

export type QuestionDataInput = {
  atsId?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
};

export type QuestionResponseData = BooleanResponse | DateResponse | DecimalResponse | FileResponse | MultipleChoiceResponse | SingleChoiceResponse | StringResponse | UrlResponse;

export type Region = {
  __typename: 'Region';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RemapJobInput = {
  id: Scalars['ID'];
  originalUrl?: InputMaybe<Scalars['String']>;
};

export type RequestCompanyInput = {
  name?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Response = {
  __typename: 'Response';
  message: Maybe<Scalars['String']>;
  status: ResponseStatus;
};

/** Response status indicating success (ok) or failure (error) */
export enum ResponseStatus {
  Error = 'ERROR',
  Ok = 'OK'
}

export type RocketListEntry = {
  __typename: 'RocketListEntry';
  company: Company;
  id: Scalars['ID'];
  listLocation: Scalars['String'];
  year: Scalars['Int'];
};

/** The possible options for the role of a user */
export enum RoleType {
  /** The user is an Otta employee */
  Admin = 'ADMIN',
  /** The user is a job-seeker */
  Candidate = 'CANDIDATE',
  /** The user is a recruiter for a company hiring on Otta */
  CompanyRecruiter = 'COMPANY_RECRUITER',
  /** The user is a researcher for data on companies */
  ExternalResearcher = 'EXTERNAL_RESEARCHER',
  /** The user is an Otta employee on the operations team responsible for processing jobs */
  InternalOperator = 'INTERNAL_OPERATOR'
}

export type RootMutationType = {
  __typename: 'RootMutationType';
  acceptJobPreferenceSuggestion: Maybe<JobPreferenceSuggestion>;
  /** Add an acquisition_channel to a given company */
  addAcquisitionChannelToCompany: Company;
  addUserPermission: Maybe<User>;
  approveCompany: Company;
  /** Archive a job at the current recruiter's current company */
  archiveCompanyJob: Maybe<Job>;
  /** Authorize access to a company's ATS */
  authorizeAtsIntegration: Maybe<Company>;
  /** Auto populates a user's job preferences based on an existing job */
  autoPopulatePreferences: Maybe<User>;
  /** Change a user's password */
  changePassword: Maybe<User>;
  /** Confirm that a job is still live */
  confirmJobLive: Maybe<Job>;
  /** Update the current user's role into a candidate role */
  convertCurrentUserToCandidate: Maybe<User>;
  /** Update the current user's role into a recruiter role */
  convertCurrentUserToRecruiter: Maybe<User>;
  /** Create a candidate's response to a context question */
  createCandidateContextQuestionResponse: Maybe<CandidateContextQuestionResponse>;
  /** Create a message within a conversation between a candidate and a company recruiter */
  createCandidateConversationMessage: Maybe<CandidateConversationMessage>;
  /** Create the same message in multiple conversations between candidates and a company recruiter */
  createCandidateConversationMessages: Maybe<Array<Maybe<ConversationMessage>>>;
  /** Create and upload a candidate's CV PDF */
  createCandidateCvPdf: Maybe<UrlObject>;
  /** Create a message request to a candidate for a specific job */
  createCandidateMessageRequest: Maybe<Candidate>;
  /** Create a reaction about a candidate for a specific job */
  createCandidateReaction: Maybe<User>;
  /** Create a view for a candidates by a company */
  createCandidateView: Maybe<Candidate>;
  /** Create a company */
  createCompany: Maybe<Company>;
  /** Create an additional info bullet for a given company */
  createCompanyAdditionalInfoBullet: Maybe<CompanyAdditionalInfoBullet>;
  /** Create an article for a given company */
  createCompanyArticle: Maybe<CompanyArticle>;
  /** Create a diversity initiative for a given company */
  createCompanyDiversityInitiative: Maybe<CompanyDiversityInitiative>;
  /** Create a new employee survey */
  createCompanyEmployeeSurvey: Maybe<CompanyEmployeeSurvey>;
  /** Create a founder for a given company */
  createCompanyFounder: Maybe<CompanyFounder>;
  /** Create a funding round for a given company */
  createCompanyFundingRound: Maybe<CompanyFundingRound>;
  /** Create a market bullet for a given company */
  createCompanyMarketBullet: Maybe<CompanyMarketBullet>;
  /** Create an other benefit bullet for a given company */
  createCompanyOtherBenefit: Maybe<CompanyOtherBenefit>;
  /** Create a person progressing for a given company */
  createCompanyPersonProgressing: Maybe<CompanyPersonProgressing>;
  /**
   * Creates a new company recruiter user
   * @deprecated Deprecated in favour of POST /auth/signup
   */
  createCompanyRecruiterUser: Maybe<User>;
  /** Create a value for a given company */
  createCompanyValue: Maybe<CompanyValue>;
  /** Create an imported candidate */
  createImportedCandidate: JobPipeline;
  /** Create an investor for a given company */
  createInvestor: Maybe<Investor>;
  /** Create a job */
  createJob: Maybe<Job>;
  /** Create an application process bullet for a given job */
  createJobApplicationProcessBullet: Maybe<JobApplicationProcessBullet>;
  /** Create & send a broadcast for a job */
  createJobBroadcast: JobBroadcast;
  /** Create an involves bullet for a given job */
  createJobInvolvesBullet: Maybe<JobInvolvesBullet>;
  /** Report a problem for a job */
  createJobProblem: JobProblem;
  /** Creates a new reaction to a job */
  createJobReaction: Maybe<JobReaction>;
  /** Create a requirement for a given job */
  createJobRequirement: Maybe<JobRequirement>;
  /** Create a language requirement for a given job */
  createLanguageRequirement: Maybe<JobLanguageRequirement>;
  /** Create a message template */
  createMessageTemplate: MessageTemplate;
  /** Create a new pipeline stage */
  createPipelineStage: JobPipeline;
  /** Create a scrape request */
  createScrapeRequest: UserScrapeRequest;
  /** Create or update sector tag for a given company */
  createSectorTag: Maybe<SectorTag>;
  /** Create a technology used for a given job */
  createTechnologyUsed: Maybe<JobTechnologyUsed>;
  /**
   * Creates a new user
   * @deprecated Deprecated in favour of POST /auth/signup
   */
  createUser: Maybe<User>;
  /** Create a user's education experience item */
  createUserEducationExperience: Maybe<UserEducationExperience>;
  /** Create a user's project item */
  createUserProject: Maybe<UserProject>;
  /** Create a user's work experience item */
  createUserWorkExperience: Maybe<UserWorkExperience>;
  /** Create a suggestion for a work experience by work experience ID */
  createWorkExperienceSuggestion: Maybe<UserWorkExperienceSuggestion>;
  /** Delete a candidate's response to a context question */
  deleteCandidateContextQuestionResponse: Maybe<CandidateContextQuestionResponse>;
  /** Delete a company */
  deleteCompany: Maybe<Company>;
  /** Delete an additional info bullet for a given company */
  deleteCompanyAdditionalInfoBullet: Maybe<CompanyAdditionalInfoBullet>;
  /** Delete an article for a given company */
  deleteCompanyArticle: Maybe<CompanyArticle>;
  /** Delete a company ATS API key */
  deleteCompanyAtsApiKey: CompanyAtsApiKey;
  /** Delete a diversity initiative for a given company */
  deleteCompanyDiversityInitiative: Maybe<CompanyDiversityInitiative>;
  /** Delete a founder for a given company */
  deleteCompanyFounder: Maybe<CompanyFounder>;
  /** Delete a funding round for a given company */
  deleteCompanyFundingRound: Maybe<CompanyFundingRound>;
  /** Delete a market bullet for a given company */
  deleteCompanyMarketBullet: Maybe<CompanyMarketBullet>;
  /** Delete an other benefit bullet for a given company */
  deleteCompanyOtherBenefit: Maybe<CompanyOtherBenefit>;
  /** Delete a person progressing for a given company */
  deleteCompanyPersonProgressing: Maybe<CompanyPersonProgressing>;
  /** Delete a company photo */
  deleteCompanyPhoto: Maybe<Company>;
  /** Delete a value for a given company */
  deleteCompanyValue: Maybe<CompanyValue>;
  /** Permanently delete the current user and all associated data */
  deleteCurrentUser: Maybe<User>;
  /** Delete an application process bullet for a given job */
  deleteJobApplicationProcessBullet: Maybe<JobApplicationProcessBullet>;
  /**
   * Delete a response to a job application question
   * @deprecated Use upsert_job_application_data
   */
  deleteJobApplicationQuestionResponse: Maybe<JobApplicationQuestionResponse>;
  /** Delete an involves bullet for a given job */
  deleteJobInvolvesBullet: Maybe<JobInvolvesBullet>;
  /** Delete all the job reactions for a user */
  deleteJobReactions: Array<JobReaction>;
  /**
   * Delete job recommendation for user
   * @deprecated No-op
   */
  deleteJobRecommendation: Maybe<JobRecommendation>;
  /**
   * Delete job recommendations for a user
   * @deprecated No-op
   */
  deleteJobRecommendations: Array<JobRecommendation>;
  /** Delete a requirement for a given job */
  deleteJobRequirement: Maybe<JobRequirement>;
  /** Delete a message template */
  deleteMessageTemplate: Maybe<MessageTemplate>;
  /** Delete a pipeline item note */
  deletePipelineItemNote: CandidatePipelineItem;
  /** Delete a pipeline stage */
  deletePipelineStage: JobPipeline;
  /** Permanently delete a user and all associated data */
  deleteUser: Maybe<User>;
  /** Delete a user's education experience item */
  deleteUserEducationExperience: Maybe<UserEducationExperience>;
  /** Delete a user's project item */
  deleteUserProject: Maybe<UserProject>;
  /** Delete a user's work experience item */
  deleteUserWorkExperience: Maybe<UserWorkExperience>;
  /** Deregister a user's device for mobile app push notifications */
  deregisterUserDevice: Scalars['String'];
  disapproveCompany: Company;
  dismissJobPreferenceSuggestion: Maybe<JobPreferenceSuggestion>;
  /** Marks a notification as dismissed for the current user */
  dismissNotification: Maybe<UserNotification>;
  /** Send a forgotten password email to a user */
  forgotPassword: Maybe<User>;
  /** Hide company from user */
  hideCompany: Maybe<PublicCompany>;
  /**
   * Logs a user in
   * @deprecated Deprecated in favour of POST /auth/login
   */
  login: Maybe<Session>;
  /**
   * Signs a user out
   * @deprecated Deprecated in favour of DELETE /auth/logout
   */
  logout: Maybe<User>;
  /** Creates a new application to a job as a signed out user */
  publicCreateJobApplication: Maybe<JobApplication>;
  /** Update a user's job notification subscription status when not logged in */
  publicUpdateUserJobNotificationUnsubscription: Scalars['Boolean'];
  pushCompanyToPro: Company;
  /** Refresh job application questions for a company */
  refreshJobApplicationQuestions: Scalars['Boolean'];
  /**
   * Refresh (delete and create) job recommendations for a user
   * @deprecated No-op
   */
  refreshJobRecommendations: Array<JobRecommendation>;
  /** Refresh Otta Certfied for your company */
  refreshOttaCertifiedStatus: Scalars['Boolean'];
  /** Register a user's device for mobile app push notifications */
  registerUserDevice: Scalars['String'];
  /** Updates (remaps) a company's scraper_url and job's original_urls */
  remapCompanyJobs: Maybe<Company>;
  /** Remove the association between a acquitision_channel_type and a given company */
  removeAcquisitionChannelFromCompany: Company;
  /** Remove the association between an investor and a given company */
  removeInvestor: Maybe<Company>;
  /** Remove the association between a language requirement and a given job */
  removeLanguageRequirement: Maybe<Job>;
  /** Remove the association between a sector tag and a given company */
  removeSectorTag: Maybe<Company>;
  /** Remove the association between a technology used and a given job */
  removeTechnologyUsed: Maybe<Job>;
  removeUserPermission: Maybe<User>;
  /** Request a company */
  requestCompany: Maybe<Company>;
  /** Reset credentials for a company's ATS */
  resetAtsIntegration: Maybe<Company>;
  /** Move sourced candidates back to talent pool */
  restoreCandidatesToPool: Maybe<Job>;
  /** Send a candidate to a company's ATS for a specific job */
  sendCandidateToAts: Maybe<Candidate>;
  /** Send an email verification email to a user */
  sendUserEmailVerification: Maybe<User>;
  /** Set the technologies used for a given job */
  setTechnologiesUsed: Maybe<Job>;
  /** Stars a job */
  starJob: Maybe<JobReaction>;
  /**
   * Unhide multiple companies from user
   * @deprecated hidden companies has moved into preferences - use update current user instead
   */
  unhideCompanies: Array<PublicCompany>;
  /** Unhide company from user */
  unhideCompany: Maybe<PublicCompany>;
  /** Update a candidate's response to a context question */
  updateCandidateContextQuestionResponse: Maybe<CandidateContextQuestionResponse>;
  /** Update a message request received by a candidate */
  updateCandidateMessageRequest: Maybe<CandidateMessageRequest>;
  /** Update a message request by conversation id */
  updateCandidateMessageRequestByConversation: Maybe<Conversation>;
  /** Update a pipeline item's stage */
  updateCandidatePipelineItemStage: JobPipeline;
  /** Update information about a company */
  updateCompany: Maybe<Company>;
  /** Update an additional info bullet for a given company */
  updateCompanyAdditionalInfoBullet: Maybe<CompanyAdditionalInfoBullet>;
  /** Update an article for a given company */
  updateCompanyArticle: Maybe<CompanyArticle>;
  /** Update a candidate conversation as a company recruiter */
  updateCompanyConversation: Maybe<CompanyConversation>;
  /** Update a diversity initiative for a given company */
  updateCompanyDiversityInitiative: Maybe<CompanyDiversityInitiative>;
  /** Update a single employee survey's category response */
  updateCompanyEmployeeSurveyCategoryResponse: Maybe<CompanyEmployeeSurveyCategoryResponse>;
  /** Update an employee survey's category responses */
  updateCompanyEmployeeSurveyCategoryResponses: Maybe<CompanyEmployeeSurvey>;
  /** Approve or disapprove submitted employee survey */
  updateCompanyEmployeeSurveyIsApproved: Maybe<CompanyEmployeeSurvey>;
  /** Update a employee survey that it has been submitted */
  updateCompanyEmployeeSurveySubmittedAt: Maybe<CompanyEmployeeSurvey>;
  /** Update a founder for a given company */
  updateCompanyFounder: Maybe<CompanyFounder>;
  /** Update a funding round for a given company */
  updateCompanyFundingRound: Maybe<CompanyFundingRound>;
  /** Update a job at the current recruiter's current company */
  updateCompanyJob: Maybe<Job>;
  /** Update a job application as a company recruiter */
  updateCompanyJobApplicationConversation: Maybe<CompanyConversation>;
  /** Update a market bullet for a given company */
  updateCompanyMarketBullet: Maybe<CompanyMarketBullet>;
  /** Update an other benefit bullet for a given company */
  updateCompanyOtherBenefit: Maybe<CompanyOtherBenefit>;
  /** Update a person progressing for a given company */
  updateCompanyPersonProgressing: Maybe<CompanyPersonProgressing>;
  /** Add or remove a product for a given company */
  updateCompanyProduct: Maybe<Product>;
  /** Update a company recruiter's company role */
  updateCompanyRole: Maybe<CompanyRecruiter>;
  /** Update a value for a given company */
  updateCompanyValue: Maybe<CompanyValue>;
  /** Update the workflow status for a given company */
  updateCompanyWorkflowStatus: Maybe<Company>;
  /** Update a conversation's read status */
  updateConversationMessageRead: Maybe<CandidateConversationMessage>;
  /** Update the current candidate */
  updateCurrentCandidate: Maybe<CurrentUser>;
  /** Update the current user */
  updateCurrentUser: Maybe<User>;
  /** Update current users timezone by location */
  updateCurrentUserTimezone: Maybe<User>;
  /** Update the current user via email */
  updateCurrentUserViaEmail: Maybe<User>;
  /** Update an imported candidate */
  updateImportedCandidate: JobPipeline;
  /** Update a job */
  updateJob: Maybe<Job>;
  /** Update the latest application of the user to a job */
  updateJobApplication: Maybe<JobApplication>;
  /** Update whether a job application has been externally responded */
  updateJobApplicationExternalResponded: Maybe<JobApplication>;
  /** Update an application process bullet for a given job */
  updateJobApplicationProcessBullet: Maybe<JobApplicationProcessBullet>;
  /** Create or update the function for a given job */
  updateJobFunction: Maybe<JobFunction>;
  /**
   * Update a candidate's rating feedback about a job interview
   * @deprecated replaced by check interview feedback received
   */
  updateJobInterviewCandidateRatingFeedback: Maybe<JobInterviewCandidateFeedback>;
  /** Update job interview feedback received */
  updateJobInterviewFeedbackReceived: Maybe<JobInterview>;
  /** Update an involves bullet for a given job */
  updateJobInvolvesBullet: Maybe<JobInvolvesBullet>;
  /** Update a job offer as a company recruiter */
  updateJobOffer: JobOffer;
  /** Update a requirement for a given job */
  updateJobRequirement: Maybe<JobRequirement>;
  /** Create or update the sub-function for a given job */
  updateJobSubFunction: Maybe<JobSubFunction>;
  /** Update the workflow status for a given job */
  updateJobWorkflowStatus: Maybe<Job>;
  /** Update the workflow status for a batch of jobs */
  updateJobWorkflowStatusBatch: Array<Job>;
  updateLastActive: Maybe<User>;
  /** Update a message template */
  updateMessageTemplate: MessageTemplate;
  /** Updates a user's opt in preferences */
  updateOptInPreferences: Scalars['Boolean'];
  /** Update a pipeline item's stage */
  updatePipelineItemStage: JobPipeline;
  /** Update a pipeline stage */
  updatePipelineStage: JobPipeline;
  /**
   * Update a salary preference
   * @deprecated use upsert_salary_preference
   */
  updateSalaryPreference: Maybe<SalaryPreference>;
  /** Hide or show the salary for a job */
  updateSalaryVisibility: Maybe<Job>;
  /** Update a user's status for a given shortlist job */
  updateShortlistUserJobStatus: Job;
  /** Approve or disapprove submitted salaries */
  updateSubmittedSalary: Maybe<SalaryPreference>;
  /** Update a user's activated status */
  updateUserActivatedStatus: Maybe<User>;
  /** Update a user's current company */
  updateUserCurrentCompany: Maybe<User>;
  /** Update a user's education experience by ID */
  updateUserEducationExperience: Maybe<UserEducationExperience>;
  /** Update a user's work and education experiences */
  updateUserExperiences: Maybe<User>;
  /** Update a user's job notification subscription status */
  updateUserJobNotificationUnsubscription: Scalars['Boolean'];
  /**
   * Update a user's last active time
   * @deprecated automatically updated when fetching currentUser
   */
  updateUserLastActive: Maybe<User>;
  /** Update a user's job email notification preferences */
  updateUserNotificationPreferences: Maybe<User>;
  /** Update a user's project by ID */
  updateUserProject: Maybe<UserProject>;
  /** Update a user's role */
  updateUserRole: Maybe<User>;
  /** Update a user's work experience by ID */
  updateUserWorkExperience: Maybe<UserWorkExperience>;
  /** Update permissions to view salary for a job */
  updateViewSalaryPermission: Maybe<Job>;
  /** Update a suggestion's status for a user's work experience by suggestion ID */
  updateWorkExperienceSuggestionStatus: Maybe<UserWorkExperienceSuggestion>;
  /** Upload an email-compatible logo for a given company */
  uploadCompanyEmailLogo: Maybe<Company>;
  /** Upload an favicon for a given company */
  uploadCompanyFavicon: Maybe<Company>;
  /** Upload a logo for a given company */
  uploadCompanyLogo: Maybe<Company>;
  /** Upload a photo for a given company */
  uploadCompanyPhoto: Maybe<Company>;
  /** Upload an image */
  uploadImage: Maybe<File>;
  /** Update user's profile from linkedin cv pdf */
  uploadLinkedinCv: Maybe<User>;
  /** Upload a profile image for the current user */
  uploadUserProfileImage: Maybe<User>;
  /** Upsert a company ATS API key */
  upsertCompanyAtsApiKey: CompanyAtsApiKey;
  /** Upsert job application data */
  upsertJobApplicationData: JobApplicationData;
  /**
   * Upsert a response to a job application question
   * @deprecated Use upsert_job_application_data
   */
  upsertJobApplicationQuestionResponse: Maybe<JobApplicationQuestionResponse>;
  /** Upsert a pipeline item note */
  upsertPipelineItemNote: CandidatePipelineItemNote;
  /** Upsert a salary preference */
  upsertSalaryPreference: Maybe<SalaryPreference>;
  /** Profile viewed by a user */
  userProfileViewed: Maybe<UserProfileView>;
  /** Verify a user's email with a token */
  verifyEmail: Maybe<User>;
};


export type RootMutationTypeAcceptJobPreferenceSuggestionArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeAddAcquisitionChannelToCompanyArgs = {
  companyId: Scalars['ID'];
  value: Scalars['String'];
};


export type RootMutationTypeAddUserPermissionArgs = {
  permissionId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeApproveCompanyArgs = {
  companyId: Scalars['ID'];
};


export type RootMutationTypeArchiveCompanyJobArgs = {
  autoDecline?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type RootMutationTypeAuthorizeAtsIntegrationArgs = {
  ats: CompanyAts;
  code: Scalars['String'];
};


export type RootMutationTypeAutoPopulatePreferencesArgs = {
  jobExternalId: Scalars['ID'];
};


export type RootMutationTypeChangePasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type RootMutationTypeConfirmJobLiveArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeConvertCurrentUserToRecruiterArgs = {
  termsConditionsConsent?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeCreateCandidateContextQuestionResponseArgs = {
  featuredAnswer?: InputMaybe<Scalars['Boolean']>;
  questionId: Scalars['ID'];
  value: Scalars['String'];
};


export type RootMutationTypeCreateCandidateConversationMessageArgs = {
  content: Scalars['String'];
  conversationId: Scalars['ID'];
};


export type RootMutationTypeCreateCandidateConversationMessagesArgs = {
  candidateIds: Array<Scalars['ID']>;
  content: Scalars['String'];
  jobId: Scalars['ID'];
};


export type RootMutationTypeCreateCandidateCvPdfArgs = {
  candidateId?: InputMaybe<Scalars['ID']>;
  jobId?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeCreateCandidateMessageRequestArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
  message: Scalars['String'];
};


export type RootMutationTypeCreateCandidateReactionArgs = {
  candidateId: Scalars['ID'];
  direction: Scalars['Boolean'];
  jobId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateCandidateViewArgs = {
  candidateExternalId: Scalars['ID'];
  jobExternalId: Scalars['ID'];
};


export type RootMutationTypeCreateCompanyArgs = {
  name: Scalars['String'];
};


export type RootMutationTypeCreateCompanyAdditionalInfoBulletArgs = {
  companyId: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


export type RootMutationTypeCreateCompanyArticleArgs = {
  companyId: Scalars['ID'];
  input: CompanyArticleInput;
};


export type RootMutationTypeCreateCompanyDiversityInitiativeArgs = {
  companyId: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


export type RootMutationTypeCreateCompanyEmployeeSurveyArgs = {
  companyId: Scalars['ID'];
  email: Scalars['String'];
  jobFunctionId: Scalars['ID'];
};


export type RootMutationTypeCreateCompanyFounderArgs = {
  companyId: Scalars['ID'];
  input: CompanyFounderInput;
};


export type RootMutationTypeCreateCompanyFundingRoundArgs = {
  companyId: Scalars['ID'];
  input: CompanyFundingRoundInput;
};


export type RootMutationTypeCreateCompanyMarketBulletArgs = {
  companyId: Scalars['ID'];
  value: Scalars['String'];
};


export type RootMutationTypeCreateCompanyOtherBenefitArgs = {
  companyId: Scalars['ID'];
  location?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};


export type RootMutationTypeCreateCompanyPersonProgressingArgs = {
  companyId: Scalars['ID'];
  input: CompanyPersonProgressingInput;
};


export type RootMutationTypeCreateCompanyRecruiterUserArgs = {
  input: NewUserInput;
};


export type RootMutationTypeCreateCompanyValueArgs = {
  companyId: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


export type RootMutationTypeCreateImportedCandidateArgs = {
  input: ImportedCandidateInput;
};


export type RootMutationTypeCreateInvestorArgs = {
  companyId: Scalars['ID'];
  topInvestor?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};


export type RootMutationTypeCreateJobArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  inToolbox?: InputMaybe<Scalars['Boolean']>;
  input: JobInput;
};


export type RootMutationTypeCreateJobApplicationProcessBulletArgs = {
  jobId: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeCreateJobBroadcastArgs = {
  jobId: Scalars['ID'];
  message: Scalars['String'];
};


export type RootMutationTypeCreateJobInvolvesBulletArgs = {
  jobId: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeCreateJobProblemArgs = {
  content: Scalars['String'];
  jobId: Scalars['ID'];
};


export type RootMutationTypeCreateJobReactionArgs = {
  direction: Scalars['Boolean'];
  jobId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeCreateJobRequirementArgs = {
  desirable?: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeCreateLanguageRequirementArgs = {
  jobId: Scalars['ID'];
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeCreateMessageTemplateArgs = {
  message: Scalars['String'];
  name: Scalars['String'];
  type?: InputMaybe<MessageTemplateTypeEnum>;
};


export type RootMutationTypeCreatePipelineStageArgs = {
  insertAfterStageId: Scalars['ID'];
  jobId: Scalars['ID'];
  name: Scalars['String'];
};


export type RootMutationTypeCreateScrapeRequestArgs = {
  url: Scalars['String'];
};


export type RootMutationTypeCreateSectorTagArgs = {
  companyId: Scalars['ID'];
  value: Scalars['String'];
};


export type RootMutationTypeCreateTechnologyUsedArgs = {
  jobId: Scalars['ID'];
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeCreateUserArgs = {
  input: NewUserInput;
};


export type RootMutationTypeCreateUserEducationExperienceArgs = {
  input: UserEducationExperienceInput;
};


export type RootMutationTypeCreateUserProjectArgs = {
  image?: InputMaybe<Scalars['Upload']>;
  input: UserProjectInput;
};


export type RootMutationTypeCreateUserWorkExperienceArgs = {
  input: UserWorkExperienceInput;
};


export type RootMutationTypeCreateWorkExperienceSuggestionArgs = {
  workExperienceId: Scalars['ID'];
};


export type RootMutationTypeDeleteCandidateContextQuestionResponseArgs = {
  responseId: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyAdditionalInfoBulletArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyArticleArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyAtsApiKeyArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyDiversityInitiativeArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyFounderArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyFundingRoundArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyMarketBulletArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyOtherBenefitArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyPersonProgressingArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyPhotoArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteCompanyValueArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteJobApplicationProcessBulletArgs = {
  id: Scalars['ID'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeDeleteJobApplicationQuestionResponseArgs = {
  responseId: Scalars['ID'];
};


export type RootMutationTypeDeleteJobInvolvesBulletArgs = {
  id: Scalars['ID'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeDeleteJobReactionsArgs = {
  userId: Scalars['ID'];
};


export type RootMutationTypeDeleteJobRecommendationArgs = {
  jobId: Scalars['ID'];
};


export type RootMutationTypeDeleteJobRecommendationsArgs = {
  jobId?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDeleteJobRequirementArgs = {
  id: Scalars['ID'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeDeleteMessageTemplateArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeletePipelineItemNoteArgs = {
  itemId: Scalars['ID'];
  jobId: Scalars['ID'];
  noteId: Scalars['ID'];
};


export type RootMutationTypeDeletePipelineStageArgs = {
  jobId: Scalars['ID'];
  stageId: Scalars['ID'];
};


export type RootMutationTypeDeleteUserArgs = {
  userId: Scalars['ID'];
};


export type RootMutationTypeDeleteUserEducationExperienceArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteUserProjectArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteUserWorkExperienceArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeregisterUserDeviceArgs = {
  devicePlatform: DevicePlatform;
  deviceToken: Scalars['String'];
};


export type RootMutationTypeDisapproveCompanyArgs = {
  companyId: Scalars['ID'];
};


export type RootMutationTypeDismissJobPreferenceSuggestionArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDismissNotificationArgs = {
  notificationName: Scalars['String'];
};


export type RootMutationTypeForgotPasswordArgs = {
  email: Scalars['String'];
};


export type RootMutationTypeHideCompanyArgs = {
  companyId: Scalars['ID'];
};


export type RootMutationTypeLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type RootMutationTypeLogoutArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypePublicCreateJobApplicationArgs = {
  jobId: Scalars['ID'];
  userExternalId: Scalars['ID'];
};


export type RootMutationTypePublicUpdateUserJobNotificationUnsubscriptionArgs = {
  jobId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypePushCompanyToProArgs = {
  companyId: Scalars['ID'];
};


export type RootMutationTypeRefreshJobApplicationQuestionsArgs = {
  companyId: Scalars['ID'];
};


export type RootMutationTypeRefreshJobRecommendationsArgs = {
  ignoreSubfunctions?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeRegisterUserDeviceArgs = {
  devicePlatform: DevicePlatform;
  deviceToken: Scalars['String'];
};


export type RootMutationTypeRemapCompanyJobsArgs = {
  id: Scalars['ID'];
  jobs: Array<RemapJobInput>;
  moveToInternal: Scalars['Boolean'];
  scraperUrl: Scalars['String'];
};


export type RootMutationTypeRemoveAcquisitionChannelFromCompanyArgs = {
  acquisitionChannelId: Scalars['ID'];
  companyId: Scalars['ID'];
};


export type RootMutationTypeRemoveInvestorArgs = {
  companyId: Scalars['ID'];
  investorId: Scalars['ID'];
};


export type RootMutationTypeRemoveLanguageRequirementArgs = {
  jobId: Scalars['ID'];
  languageRequirementId: Scalars['ID'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeRemoveSectorTagArgs = {
  companyId: Scalars['ID'];
  sectorTagId: Scalars['ID'];
};


export type RootMutationTypeRemoveTechnologyUsedArgs = {
  jobId: Scalars['ID'];
  technologyUsedId: Scalars['ID'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeRemoveUserPermissionArgs = {
  permissionId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeRequestCompanyArgs = {
  input: RequestCompanyInput;
};


export type RootMutationTypeResetAtsIntegrationArgs = {
  companyId: Scalars['ID'];
};


export type RootMutationTypeRestoreCandidatesToPoolArgs = {
  jobId: Scalars['ID'];
};


export type RootMutationTypeSendCandidateToAtsArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
};


export type RootMutationTypeSendUserEmailVerificationArgs = {
  email: Scalars['String'];
};


export type RootMutationTypeSetTechnologiesUsedArgs = {
  jobId: Scalars['ID'];
  values: Array<Scalars['String']>;
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeStarJobArgs = {
  jobId: Scalars['ID'];
};


export type RootMutationTypeUnhideCompaniesArgs = {
  companyIds: Array<Scalars['ID']>;
};


export type RootMutationTypeUnhideCompanyArgs = {
  companyId: Scalars['ID'];
};


export type RootMutationTypeUpdateCandidateContextQuestionResponseArgs = {
  featuredAnswer?: InputMaybe<Scalars['Boolean']>;
  questionId?: InputMaybe<Scalars['ID']>;
  responseId: Scalars['ID'];
  value: Scalars['String'];
};


export type RootMutationTypeUpdateCandidateMessageRequestArgs = {
  accepted: Scalars['Boolean'];
  candidateResponse: Scalars['String'];
  candidateViewed?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type RootMutationTypeUpdateCandidateMessageRequestByConversationArgs = {
  accepted: Scalars['Boolean'];
  candidateResponse: Scalars['String'];
  candidateViewed?: InputMaybe<Scalars['Boolean']>;
  conversationId: Scalars['ID'];
};


export type RootMutationTypeUpdateCandidatePipelineItemStageArgs = {
  itemId: Scalars['ID'];
  jobId: Scalars['ID'];
  stageId: Scalars['ID'];
};


export type RootMutationTypeUpdateCompanyArgs = {
  id: Scalars['ID'];
  input: CompanyInput;
};


export type RootMutationTypeUpdateCompanyAdditionalInfoBulletArgs = {
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


export type RootMutationTypeUpdateCompanyArticleArgs = {
  id: Scalars['ID'];
  input: CompanyArticleInput;
};


export type RootMutationTypeUpdateCompanyConversationArgs = {
  id: Scalars['ID'];
  qualified?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpdateCompanyDiversityInitiativeArgs = {
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


export type RootMutationTypeUpdateCompanyEmployeeSurveyCategoryResponseArgs = {
  content: Scalars['String'];
  id: Scalars['ID'];
  surveyExternalId: Scalars['ID'];
};


export type RootMutationTypeUpdateCompanyEmployeeSurveyCategoryResponsesArgs = {
  responses: Array<CompanyEmployeeSurveyCategoryResponseInput>;
  surveyExternalId: Scalars['ID'];
};


export type RootMutationTypeUpdateCompanyEmployeeSurveyIsApprovedArgs = {
  id: Scalars['ID'];
  isApproved: Scalars['Boolean'];
};


export type RootMutationTypeUpdateCompanyEmployeeSurveySubmittedAtArgs = {
  externalId: Scalars['ID'];
};


export type RootMutationTypeUpdateCompanyFounderArgs = {
  id: Scalars['ID'];
  input: CompanyFounderInput;
};


export type RootMutationTypeUpdateCompanyFundingRoundArgs = {
  id: Scalars['ID'];
  input: CompanyFundingRoundInput;
};


export type RootMutationTypeUpdateCompanyJobArgs = {
  id: Scalars['ID'];
  input: CompanyJobInput;
  isPreview?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpdateCompanyJobApplicationConversationArgs = {
  id: Scalars['ID'];
  input: CompanyJobApplicationInput;
};


export type RootMutationTypeUpdateCompanyMarketBulletArgs = {
  id: Scalars['ID'];
  value: Scalars['String'];
};


export type RootMutationTypeUpdateCompanyOtherBenefitArgs = {
  id: Scalars['ID'];
  location?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateCompanyPersonProgressingArgs = {
  id: Scalars['ID'];
  input: CompanyPersonProgressingInput;
};


export type RootMutationTypeUpdateCompanyProductArgs = {
  active: Scalars['Boolean'];
  companyId: Scalars['ID'];
  productId: Scalars['ID'];
};


export type RootMutationTypeUpdateCompanyRoleArgs = {
  newRole: CompanyRoleType;
  userId: Scalars['ID'];
};


export type RootMutationTypeUpdateCompanyValueArgs = {
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


export type RootMutationTypeUpdateCompanyWorkflowStatusArgs = {
  companyId: Scalars['ID'];
  workflowStatus: CompanyWorkflowStatus;
};


export type RootMutationTypeUpdateConversationMessageReadArgs = {
  messageId: Scalars['ID'];
  read: Scalars['Boolean'];
};


export type RootMutationTypeUpdateCurrentCandidateArgs = {
  input: UserInput;
};


export type RootMutationTypeUpdateCurrentUserArgs = {
  input: UserInput;
};


export type RootMutationTypeUpdateCurrentUserTimezoneArgs = {
  location?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateCurrentUserViaEmailArgs = {
  hash: Scalars['String'];
  input: UserInputViaEmail;
  userExternalId: Scalars['ID'];
};


export type RootMutationTypeUpdateImportedCandidateArgs = {
  input: ImportedCandidateInput;
};


export type RootMutationTypeUpdateJobArgs = {
  id: Scalars['ID'];
  input: JobInput;
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeUpdateJobApplicationArgs = {
  input: JobApplicationInput;
  jobId: Scalars['ID'];
};


export type RootMutationTypeUpdateJobApplicationExternalRespondedArgs = {
  externalId: Scalars['ID'];
  externalResponded?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpdateJobApplicationProcessBulletArgs = {
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeUpdateJobFunctionArgs = {
  jobId: Scalars['ID'];
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeUpdateJobInterviewCandidateRatingFeedbackArgs = {
  input: JobInterviewCandidateFeedbackInput;
  jobExternalId: Scalars['ID'];
  userExternalId: Scalars['ID'];
};


export type RootMutationTypeUpdateJobInterviewFeedbackReceivedArgs = {
  feedbackReceived: InterviewFeedbackReceived;
  id: Scalars['ID'];
};


export type RootMutationTypeUpdateJobInvolvesBulletArgs = {
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeUpdateJobOfferArgs = {
  input?: InputMaybe<JobOfferInput>;
  jobId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootMutationTypeUpdateJobRequirementArgs = {
  desirable?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeUpdateJobSubFunctionArgs = {
  jobId: Scalars['ID'];
  value: Scalars['String'];
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootMutationTypeUpdateJobWorkflowStatusArgs = {
  jobId: Scalars['ID'];
  workflowStatus: JobWorkflowStatus;
};


export type RootMutationTypeUpdateJobWorkflowStatusBatchArgs = {
  jobIds: Array<Scalars['ID']>;
  workflowStatus: JobWorkflowStatus;
};


export type RootMutationTypeUpdateMessageTemplateArgs = {
  id: Scalars['ID'];
  message: Scalars['String'];
  name: Scalars['String'];
  type?: InputMaybe<MessageTemplateTypeEnum>;
};


export type RootMutationTypeUpdateOptInPreferencesArgs = {
  optInStatus: OptInStatusEnum;
};


export type RootMutationTypeUpdatePipelineItemStageArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
  stageId: Scalars['ID'];
};


export type RootMutationTypeUpdatePipelineStageArgs = {
  jobId: Scalars['ID'];
  name: Scalars['String'];
  stageId: Scalars['ID'];
};


export type RootMutationTypeUpdateSalaryPreferenceArgs = {
  input: SalaryPreferenceInput;
};


export type RootMutationTypeUpdateSalaryVisibilityArgs = {
  hideSalary: Scalars['Boolean'];
  jobId: Scalars['ID'];
};


export type RootMutationTypeUpdateShortlistUserJobStatusArgs = {
  jobId: Scalars['ID'];
  status: UserJobStatus;
};


export type RootMutationTypeUpdateSubmittedSalaryArgs = {
  id: Scalars['ID'];
  input: SubmittedSalaryInput;
};


export type RootMutationTypeUpdateUserActivatedStatusArgs = {
  activated: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type RootMutationTypeUpdateUserCurrentCompanyArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type RootMutationTypeUpdateUserEducationExperienceArgs = {
  id: Scalars['ID'];
  input: UserEducationExperienceInput;
};


export type RootMutationTypeUpdateUserExperiencesArgs = {
  educationExperiences: Array<UserEducationExperienceInput>;
  id: Scalars['ID'];
  workExperiences: Array<UserWorkExperienceInput>;
};


export type RootMutationTypeUpdateUserJobNotificationUnsubscriptionArgs = {
  jobId: Scalars['ID'];
  unsubscribe?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUpdateUserLastActiveArgs = {
  externalId: Scalars['ID'];
};


export type RootMutationTypeUpdateUserNotificationPreferencesArgs = {
  externalId?: InputMaybe<Scalars['ID']>;
  frequency: NotificationFrequency;
};


export type RootMutationTypeUpdateUserProjectArgs = {
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['Upload']>;
  input?: InputMaybe<UserProjectInput>;
};


export type RootMutationTypeUpdateUserRoleArgs = {
  id: Scalars['ID'];
  role: RoleType;
};


export type RootMutationTypeUpdateUserWorkExperienceArgs = {
  id: Scalars['ID'];
  input: UserWorkExperienceInput;
};


export type RootMutationTypeUpdateViewSalaryPermissionArgs = {
  jobId: Scalars['ID'];
  userIds: Array<Scalars['ID']>;
};


export type RootMutationTypeUpdateWorkExperienceSuggestionStatusArgs = {
  status: WorkExperienceSuggestionStatus;
  suggestionId: Scalars['ID'];
};


export type RootMutationTypeUploadCompanyEmailLogoArgs = {
  companyId: Scalars['ID'];
  logo: Scalars['Upload'];
};


export type RootMutationTypeUploadCompanyFaviconArgs = {
  companyId: Scalars['ID'];
  favicon: Scalars['Upload'];
};


export type RootMutationTypeUploadCompanyLogoArgs = {
  companyId: Scalars['ID'];
  logo: Scalars['Upload'];
  prfix?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUploadCompanyPhotoArgs = {
  companyId: Scalars['ID'];
  image: Scalars['Upload'];
};


export type RootMutationTypeUploadImageArgs = {
  category?: InputMaybe<ImageCategory>;
  image: Scalars['Upload'];
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeUploadLinkedinCvArgs = {
  cv: Scalars['Upload'];
};


export type RootMutationTypeUploadUserProfileImageArgs = {
  image: Scalars['Upload'];
};


export type RootMutationTypeUpsertCompanyAtsApiKeyArgs = {
  companyId: Scalars['ID'];
  key: Scalars['String'];
  type: CompanyAtsApiKeyTypeEnum;
};


export type RootMutationTypeUpsertJobApplicationDataArgs = {
  data: JobApplicationDataInput;
  jobApplicationId: Scalars['ID'];
};


export type RootMutationTypeUpsertJobApplicationQuestionResponseArgs = {
  atsQuestionId?: InputMaybe<Scalars['String']>;
  input?: InputMaybe<ApplicationQuestionResponseInput>;
  jobId: Scalars['ID'];
  question: Scalars['String'];
};


export type RootMutationTypeUpsertPipelineItemNoteArgs = {
  content: Scalars['String'];
  itemId: Scalars['ID'];
  jobId: Scalars['ID'];
};


export type RootMutationTypeUpsertSalaryPreferenceArgs = {
  input: SalaryPreferenceInput;
};


export type RootMutationTypeUserProfileViewedArgs = {
  jobApplicationId: Scalars['ID'];
};


export type RootMutationTypeVerifyEmailArgs = {
  token: Scalars['String'];
};

export type RootQueryType = {
  __typename: 'RootQueryType';
  /** Get a list of all the products available */
  allProducts: Maybe<Array<Product>>;
  /** Get a specific candidate by external ID */
  candidate: Maybe<Candidate>;
  /** Get all of the candidate context questions */
  candidateContextQuestions: Maybe<Array<CandidateContextQuestion>>;
  /** Get a received message request by it's job ID */
  candidateReceivedMessageRequest: Maybe<CandidateMessageRequest>;
  /** Get the shortlist of candidates for a specific job */
  candidateShortlist: Maybe<Array<Candidate>>;
  /** Get a list of all companies */
  companies: Array<PublicCompany>;
  /** Get a list of all companies by external id */
  companiesByExternalId: Array<Company>;
  /** Get information about a specific company */
  company: Maybe<Company>;
  /** Get all acquisition_channels */
  companyAcquisitionChannels: Array<AcquisitionChannel>;
  /** Get boost values */
  companyBoost: Boost;
  /** Get information about a specific company by name */
  companyByName: Maybe<Company>;
  /** Get a company conversation by its ID */
  companyConversation: CompanyConversation;
  /** Get a single employee survey */
  companyEmployeeSurvey: Maybe<CompanyEmployeeSurvey>;
  /** Get a list of all employee surveys pending for approval */
  companyEmployeeSurveysPendingApproval: Array<CompanyEmployeeSurvey>;
  /** Get a specific job by external ID */
  companyJob: Maybe<Job>;
  /** Get a list of all company qualities */
  companyQualities: Array<CompanyQuality>;
  /**
   * Gets company recruiter users with specific workflow statuses
   * @deprecated Use users with role arg instead
   */
  companyRecruiters: Array<User>;
  /** Get all of the unique company sizes */
  companySizes: Array<CompanySize>;
  /** Get a list of all company sub qualities */
  companySubQualities: Array<CompanySubQuality>;
  /** Get a candidate conversation by its ID */
  conversation: Conversation;
  /** Gets the currently logged in user */
  currentUser: Maybe<User>;
  /** Get the discarded list of candidates for a specific job */
  discardedCandidates: Maybe<Array<Candidate>>;
  /** Get all feature toggle definitions */
  featureFlags: Array<FeatureFlag>;
  /** Find imported candidate by email */
  findImportedCandidate: Maybe<ImportedCandidate>;
  /** Get all of the sub-functions under a job function */
  functionSubFunctions: Array<JobSubFunction>;
  /** Get a job pipeline */
  getJobPipeline: Maybe<JobPipeline>;
  /** Get job pipeline item */
  getJobPipelineItem: CandidatePipelineItem;
  /** Get job pipeline stages */
  getJobPipelineStages: Maybe<Array<CandidatePipelineStagePartial>>;
  /** Get a list of companies for processing */
  internalCompanies: Array<Company>;
  /** Get all of the unique investors */
  investors: Array<Investor>;
  /** Get information about a specific job */
  job: Maybe<Job>;
  /** Get the a specific job application by ID */
  jobApplication: Maybe<JobApplication>;
  /** Get a conversation id by its job application id */
  jobApplicationConversationId: Maybe<Scalars['ID']>;
  /** Get information about a specific job function */
  jobFunction: Maybe<JobFunction>;
  /** Get all of the unique job functions */
  jobFunctions: Array<JobFunction>;
  /** Get a job interview */
  jobInterview: JobInterview;
  /** Get a specific job offer */
  jobOffer: Maybe<JobOffer>;
  /** Get information about a specific job sub function */
  jobSubFunction: Maybe<JobSubFunction>;
  /** Get all of the unique job sub-functions */
  jobSubFunctions: Array<JobSubFunction>;
  /** Get all of the jobs */
  jobs: Array<Job>;
  /** Get all of the unique language requirements */
  languageRequirements: Array<JobLanguageRequirement>;
  /** Get the current user's latest job application for a given job */
  latestJobApplication: Maybe<JobApplication>;
  /** get all job recs when user is logged out */
  loggedOutJobRecommendations: Maybe<Array<JobRecommendation>>;
  /** Gets the currently logged in user */
  me: Maybe<CurrentUser>;
  /** Get a conversation id by its message request id */
  messageRequestConversationId: Maybe<Scalars['ID']>;
  /** Get a personalised list of templates */
  messageTemplates: Array<MessageTemplate>;
  /** Get next company that is ready for processing */
  nextCompanyToProcess: Maybe<Company>;
  /** Get all of the jobs */
  nextJobToProcess: Maybe<Job>;
  /** Get a the next user's profile to scrape */
  nextUserToScrape: Maybe<User>;
  permissions: Array<PermissionObject>;
  /** Get a personalised list of potential candidates for a specific job */
  personalisedCandidates: Maybe<Array<Candidate>>;
  /** Get total number of personalised candidates, sans salary requirements */
  personalisedCandidatesWithoutSalary: Scalars['Int'];
  /** Get a list of personalised companies */
  personalisedCompanies: Array<Company>;
  /** Get all of the language requirements for jobs on a user's list of personalised jobs */
  personalisedLanguageRequirements: Array<JobLanguageRequirement>;
  /** Get popular technologies used by jobs of certain sub functions */
  popularTechnologiesUsed: Array<JobTechnologyUsed>;
  /** Get information about a specific job by external ID */
  publicJob: Maybe<Job>;
  /** Get a candidate's public job application details */
  publicJobApplication: Maybe<PublicJobApplication>;
  /** Get a set of public statistics about the platform */
  publicStatistics: PublicStatistics;
  /** Get a list of all possible regions */
  regions: Array<Region>;
  /** Get a list of rocket list companies */
  rocketListEntries: Array<RocketListEntry>;
  /** Get the current user's salary preference */
  salaryPreference: Maybe<SalaryPreference>;
  /** Get a review on a Salary Range for a job */
  salaryQualityReview: SalaryQualityRating;
  /** Get a set of salary statistics */
  salaryStatistics: SalaryStatistics;
  /** Get a list of scrape requests */
  scrapeRequests: Array<UserScrapeRequest>;
  /** Get all of the unique sector tags */
  sectorTags: Array<SectorTag>;
  /** Get similar jobs to a specific job */
  similarJobs: Array<Job>;
  /** Get a set of statistics about the platform */
  statistics: Statistics;
  /** Get a list of salaries submitted by users at most 6 months ago */
  submittedSalaries: Maybe<Array<SalaryPreference>>;
  /** Get all of the unique technologies used */
  technologiesUsed: Array<JobTechnologyUsed>;
  /** Get a list of all of the available timezones */
  timezones: Array<Timezone>;
  /** Get all of the top investors */
  topInvestors: Array<Investor>;
  /** Get all of the top sector tags */
  topSectorTags: Array<TopSectorTag>;
  /** Get the total number of jobs */
  totalJobs: Maybe<Scalars['Int']>;
  /** Get a user by id */
  user: Maybe<User>;
  /** Get information about a specific education experience */
  userEducationExperience: Maybe<UserEducationExperience>;
  /** Get information about a specific education experience description */
  userEducationExperienceDescription: Maybe<EducationExperienceDescription>;
  /** Get a list of the descriptions of a specific education experience */
  userEducationExperienceDescriptions: Array<EducationExperienceDescription>;
  /** Get whether the user is subscribed to application notifications for a given job */
  userJobNotificationUnsubscription: Scalars['Boolean'];
  /** Fetch notification by page type */
  userNotification: Maybe<Notification>;
  /** Get information about a specific project */
  userProject: Maybe<UserProject>;
  /** Get information about a specific website link */
  userWebsiteLink: Maybe<WebsiteLink>;
  /** Get information about a specific work experience */
  userWorkExperience: Maybe<UserWorkExperience>;
  /** Get information about a specific work experience description */
  userWorkExperienceDescription: Maybe<WorkExperienceDescription>;
  /** Get a list of the descriptions of a specific work experience */
  userWorkExperienceDescriptions: Array<WorkExperienceDescription>;
  /** Get a list of all users */
  users: Maybe<Array<User>>;
  /** Validates an API key for an ATS */
  validateAtsApiKey: Response;
  /** Get a list of the top companies at which people work */
  workExperienceCompanies: Array<Scalars['String']>;
  /** Get a work experience suggestion by work experience ID */
  workExperienceSuggestion: Maybe<UserWorkExperienceSuggestion>;
};


export type RootQueryTypeCandidateArgs = {
  externalId: Scalars['ID'];
  jobId?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeCandidateReceivedMessageRequestArgs = {
  jobId: Scalars['ID'];
};


export type RootQueryTypeCandidateShortlistArgs = {
  jobId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type RootQueryTypeCompaniesArgs = {
  previouslyScrapedJobs?: InputMaybe<Scalars['Boolean']>;
  scraperType?: InputMaybe<ScraperType>;
  urlSafeNames?: InputMaybe<Array<Scalars['String']>>;
  workflowStatus?: InputMaybe<CompanyWorkflowStatus>;
  workflowStatuses?: InputMaybe<Array<CompanyWorkflowStatus>>;
};


export type RootQueryTypeCompaniesByExternalIdArgs = {
  externalIds?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeCompanyArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeCompanyBoostArgs = {
  jobId: Scalars['ID'];
};


export type RootQueryTypeCompanyByNameArgs = {
  name: Scalars['String'];
};


export type RootQueryTypeCompanyConversationArgs = {
  id: Scalars['ID'];
  newApplication: Scalars['Boolean'];
};


export type RootQueryTypeCompanyEmployeeSurveyArgs = {
  externalId: Scalars['ID'];
};


export type RootQueryTypeCompanyEmployeeSurveysPendingApprovalArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type RootQueryTypeCompanyJobArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeCompanyRecruitersArgs = {
  workflowStatuses?: InputMaybe<Array<CompanyWorkflowStatus>>;
};


export type RootQueryTypeConversationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeDiscardedCandidatesArgs = {
  jobId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type RootQueryTypeFindImportedCandidateArgs = {
  emailAddress: Scalars['String'];
};


export type RootQueryTypeFunctionSubFunctionsArgs = {
  functionId?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeGetJobPipelineArgs = {
  jobId: Scalars['ID'];
};


export type RootQueryTypeGetJobPipelineItemArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
};


export type RootQueryTypeGetJobPipelineStagesArgs = {
  candidateId: Scalars['ID'];
  jobId: Scalars['ID'];
};


export type RootQueryTypeInternalCompaniesArgs = {
  workflowStatus: CompanyWorkflowStatus;
};


export type RootQueryTypeInvestorsArgs = {
  onlyTop?: InputMaybe<Scalars['Boolean']>;
};


export type RootQueryTypeJobArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeJobApplicationArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeJobApplicationConversationIdArgs = {
  jobApplicationId: Scalars['ID'];
};


export type RootQueryTypeJobFunctionArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeJobInterviewArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeJobOfferArgs = {
  jobId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type RootQueryTypeJobSubFunctionArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeJobSubFunctionsArgs = {
  functionId?: InputMaybe<Scalars['ID']>;
  jobId?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeJobsArgs = {
  lastChangedByRoles?: InputMaybe<Array<RoleType>>;
  limit?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<Location>>;
  offset?: InputMaybe<Scalars['Int']>;
  subFunctionIds?: InputMaybe<Array<Scalars['ID']>>;
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootQueryTypeLatestJobApplicationArgs = {
  jobId: Scalars['ID'];
};


export type RootQueryTypeLoggedOutJobRecommendationsArgs = {
  preferredSectorId?: InputMaybe<Scalars['ID']>;
  sectorTagIds?: InputMaybe<Array<Scalars['Int']>>;
  themeId?: InputMaybe<ThemeId>;
};


export type RootQueryTypeMessageRequestConversationIdArgs = {
  messageRequestId: Scalars['ID'];
};


export type RootQueryTypeMessageTemplatesArgs = {
  messageTemplateType?: InputMaybe<MessageTemplateTypeEnum>;
};


export type RootQueryTypeNextCompanyToProcessArgs = {
  workflowStatus: CompanyWorkflowStatus;
};


export type RootQueryTypeNextJobToProcessArgs = {
  locations?: InputMaybe<Array<Location>>;
  subFunctionIds?: InputMaybe<Array<Scalars['ID']>>;
  workflowStatus: JobWorkflowStatus;
};


export type RootQueryTypePermissionsArgs = {
  scopes?: InputMaybe<Array<PermissionScope>>;
};


export type RootQueryTypePersonalisedCandidatesArgs = {
  filters?: InputMaybe<PersonalisedCandidateFilters>;
  jobId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypePersonalisedCandidatesWithoutSalaryArgs = {
  jobId: Scalars['ID'];
};


export type RootQueryTypePersonalisedCompaniesArgs = {
  companyName?: InputMaybe<Scalars['String']>;
  companySizes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  investorPreferences?: InputMaybe<Array<InputMaybe<InvestorPreferenceInput>>>;
  limit: Scalars['Int'];
  locationPreferences?: InputMaybe<Array<InputMaybe<Location>>>;
  offset: Scalars['Int'];
  sectorTagPreferences?: InputMaybe<Array<InputMaybe<SectorTagPreferenceInput>>>;
};


export type RootQueryTypePopularTechnologiesUsedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  subFunctions: Array<Scalars['ID']>;
};


export type RootQueryTypePublicJobArgs = {
  externalId: Scalars['ID'];
};


export type RootQueryTypePublicJobApplicationArgs = {
  externalId: Scalars['ID'];
};


export type RootQueryTypeRocketListEntriesArgs = {
  companySizes?: InputMaybe<Array<Scalars['ID']>>;
  hiringInLocations?: InputMaybe<Array<Location>>;
  location: Scalars['String'];
  sectorCategories?: InputMaybe<Array<Scalars['ID']>>;
  sectors?: InputMaybe<Array<Scalars['ID']>>;
  year: Scalars['Int'];
};


export type RootQueryTypeSalaryQualityReviewArgs = {
  jobId: Scalars['ID'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};


export type RootQueryTypeScrapeRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeSimilarJobsArgs = {
  excludedJobs: Array<Scalars['ID']>;
  jobId: Scalars['ID'];
  limit: Scalars['Int'];
};


export type RootQueryTypeSubmittedSalariesArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type RootQueryTypeTopInvestorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeTopSectorTagsArgs = {
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeTotalJobsArgs = {
  lastChangedByRoles?: InputMaybe<Array<RoleType>>;
  locations?: InputMaybe<Array<Location>>;
  subFunctionIds?: InputMaybe<Array<Scalars['ID']>>;
  workflowStatus?: InputMaybe<JobWorkflowStatus>;
};


export type RootQueryTypeUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeUserEducationExperienceArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserEducationExperienceDescriptionArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserEducationExperienceDescriptionsArgs = {
  educationExperienceId: Scalars['ID'];
};


export type RootQueryTypeUserJobNotificationUnsubscriptionArgs = {
  jobId: Scalars['ID'];
};


export type RootQueryTypeUserNotificationArgs = {
  pageType: Scalars['String'];
};


export type RootQueryTypeUserProjectArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserWebsiteLinkArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserWorkExperienceArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserWorkExperienceDescriptionArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeUserWorkExperienceDescriptionsArgs = {
  workExperienceId: Scalars['ID'];
};


export type RootQueryTypeUsersArgs = {
  activated?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyWorkflowStatus?: InputMaybe<Array<CompanyWorkflowStatus>>;
  email?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<RoleType>;
};


export type RootQueryTypeValidateAtsApiKeyArgs = {
  ats: CompanyAts;
  atsApiKey: Scalars['String'];
};


export type RootQueryTypeWorkExperienceSuggestionArgs = {
  workExperienceId: Scalars['ID'];
};

export type SalaryPreference = {
  __typename: 'SalaryPreference';
  companyOnOtta: Maybe<Scalars['Boolean']>;
  currentCompany: Maybe<Scalars['String']>;
  currentExperienceLevel: Maybe<ExperienceLevel>;
  currentFunction: Maybe<JobFunction>;
  currentJobSalary: Maybe<Money>;
  currentJobTitle: Maybe<Scalars['String']>;
  /** @deprecated Use current_job_salary instead */
  currentSalary: Maybe<Scalars['Int']>;
  currentSubFunction: Maybe<JobSubFunction>;
  email: Maybe<Scalars['String']>;
  experienceLevel: Maybe<ExperienceLevel>;
  externalId: Scalars['ID'];
  genders: Array<Gender>;
  hasAssociatedUser: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  location: Maybe<Location>;
};

export type SalaryPreferenceInput = {
  currentCompany?: InputMaybe<Scalars['String']>;
  currentExperienceLevel?: InputMaybe<ExperienceLevel>;
  currentFunctionId?: InputMaybe<Scalars['ID']>;
  currentJobSalary?: InputMaybe<MoneyInput>;
  currentJobTitle?: InputMaybe<Scalars['String']>;
  currentSalary?: InputMaybe<Scalars['Int']>;
  currentSubFunctionId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  experienceLevel?: InputMaybe<ExperienceLevel>;
  genders?: InputMaybe<Array<Gender>>;
  location?: InputMaybe<Location>;
};

/** The options for salary quality rating from the Salary Wizard */
export enum SalaryQualityRating {
  Broad = 'BROAD',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Low = 'LOW',
  NotEnoughMatchingCandidates = 'NOT_ENOUGH_MATCHING_CANDIDATES'
}

export type SalaryStatistics = {
  __typename: 'SalaryStatistics';
  /** Examples of jobs with salaries for this sub function and location */
  exampleJobs: Array<Job>;
  salaryTrajectory: SalaryTrajectoryData;
};


export type SalaryStatisticsExampleJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  location: Location;
  subFunctionId: Scalars['ID'];
};


export type SalaryStatisticsSalaryTrajectoryArgs = {
  experienceLevels?: InputMaybe<Array<ExperienceLevel>>;
  location: Location;
  percentile: Scalars['Float'];
  subFunctionId: Scalars['ID'];
};

export type SalaryTrajectoryData = {
  __typename: 'SalaryTrajectoryData';
  currency: Currency;
  datapoints: Array<SalaryTrajectoryDatapoint>;
  numRawDatapoints: Scalars['Int'];
};

export type SalaryTrajectoryDatapoint = {
  __typename: 'SalaryTrajectoryDatapoint';
  label: Scalars['String'];
  value: Scalars['Int'];
};

export enum ScrapeRequestStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** The specific scraper type (normally a job board) */
export enum ScraperType {
  /** The Amazon scraper */
  Amazon = 'AMAZON',
  /** The Apple scraper */
  Apple = 'APPLE',
  /** The BambooHR scraper */
  Bamboohr = 'BAMBOOHR',
  /** The BreezyHR scraper */
  Breezy = 'BREEZY',
  /** The generic scraper designed to scrape companies who publish JobPosting schemas */
  GenericSchema = 'GENERIC_SCHEMA',
  /** The Greenhouse.io scraper */
  Greenhouse = 'GREENHOUSE',
  /** The Jobvite scraper */
  Jobvite = 'JOBVITE',
  /** The Lever.co scraper */
  Lever = 'LEVER',
  /** The Recruitee scraper */
  Recruitee = 'RECRUITEE',
  /** The SmartRecruiters scraper */
  SmartRecruiters = 'SMART_RECRUITERS',
  /** The Teamtailor scraper */
  Teamtailor = 'TEAMTAILOR',
  /** The TikTok scraper */
  Tiktok = 'TIKTOK',
  /** The Twitter scraper */
  Twitter = 'TWITTER',
  /** The Workable.com scraper */
  Workable = 'WORKABLE',
  /** The Workday scraper */
  Workday = 'WORKDAY'
}

export type SectorCategory = {
  __typename: 'SectorCategory';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type SectorTag = {
  __typename: 'SectorTag';
  category: Maybe<SectorCategory>;
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type SectorTagInput = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type SectorTagPreference = {
  __typename: 'SectorTagPreference';
  preference: Scalars['Boolean'];
  sectorTagId: Scalars['ID'];
};

export type SectorTagPreferenceInput = {
  id?: InputMaybe<Scalars['ID']>;
  preference: Scalars['Boolean'];
  sectorTagId?: InputMaybe<Scalars['ID']>;
};

export type Session = {
  __typename: 'Session';
  token: Scalars['String'];
};

/** The possible options for sexual orientation */
export enum SexualOrientation {
  Heterosexual = 'HETEROSEXUAL',
  Lgbqa = 'LGBQA',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type SignUpReasonResponse = {
  __typename: 'SignUpReasonResponse';
  source: Scalars['String'];
};

export type SignUpReasonResponseInput = {
  source: Scalars['String'];
};

export type SingleChoiceResponse = {
  __typename: 'SingleChoiceResponse';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SingleChoiceResponseInput = {
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SingleSelectAnswer = {
  __typename: 'SingleSelectAnswer';
  choice: Choice;
  questionData: AnswerQuestionData;
};

export type SingleSelectAnswerInput = {
  choice: ChoiceInput;
  questionData: QuestionDataInput;
};

export type SingleSelectQuestion = {
  __typename: 'SingleSelectQuestion';
  atsId: Maybe<Scalars['String']>;
  choices: Array<Choice>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

/** The possible options for a pipeline stage type */
export enum StageType {
  Applied = 'APPLIED',
  Archived = 'ARCHIVED',
  Custom = 'CUSTOM',
  Hired = 'HIRED',
  OfferSent = 'OFFER_SENT',
  Sourced = 'SOURCED'
}

export type Statistics = {
  __typename: 'Statistics';
  dailyAverageNumberJobsSaved: Scalars['Decimal'];
  fourteenDayActiveUsers: Scalars['Int'];
  liveJobsWithInternalApplications: Scalars['Int'];
  monthlyActiveUsers: Scalars['Int'];
  monthlyCandidatesApplying: Scalars['Int'];
  monthlyNumberCandidatesReceivingMessageRequests: Scalars['Int'];
  numberLiveCandidateProfiles: Scalars['Int'];
  numberLiveCompanies: Scalars['Int'];
  numberLiveJobs: Scalars['Int'];
  numberUsers: Scalars['Int'];
  percentageJobApplicationsRespondedTo: Scalars['Int'];
  percentageMessageRequestsRespondedTo: Scalars['Int'];
  percentageMessageRequestsViewed: Scalars['Int'];
  percentageRetention: Scalars['Int'];
  percentageSavedInFirstJobs: Scalars['Int'];
  sevenDayActiveCompanies: Scalars['Int'];
  sevenDayActiveUsers: Scalars['Int'];
  sevenDayApplyConfirms: Scalars['Int'];
  sevenDayCandidateReactions: Scalars['Int'];
  sevenDayInternalApplications: Scalars['Int'];
  sevenDayInterviews: Scalars['Int'];
  sevenDayMessageRequestsAccepted: Scalars['Int'];
  sevenDayMessageRequestsSent: Scalars['Int'];
  sevenDayNewUsers: Scalars['Int'];
  sevenDayOffersAccepted: Scalars['Int'];
  sevenDayOffersReceived: Scalars['Int'];
  sevenDaySavedJobs: Scalars['Int'];
  totalApplyClicks: Scalars['Int'];
  totalApplyConfirms: Scalars['Int'];
  totalApplyOpens: Scalars['Int'];
  totalUsersWithLinkedinUrl: Scalars['Int'];
  weekNewUsers: Scalars['Int'];
  weekSavedJobs: Scalars['Int'];
};


export type StatisticsDailyAverageNumberJobsSavedArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsFourteenDayActiveUsersArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsMonthlyActiveUsersArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsMonthlyCandidatesApplyingArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsMonthlyNumberCandidatesReceivingMessageRequestsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsNumberLiveCandidateProfilesArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsNumberUsersArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsPercentageJobApplicationsRespondedToArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsPercentageMessageRequestsRespondedToArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsPercentageMessageRequestsViewedArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsPercentageRetentionArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsPercentageSavedInFirstJobsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayActiveCompaniesArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayActiveUsersArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayApplyConfirmsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayCandidateReactionsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayInternalApplicationsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayInterviewsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayMessageRequestsAcceptedArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayMessageRequestsSentArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayNewUsersArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayOffersAcceptedArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDayOffersReceivedArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsSevenDaySavedJobsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsTotalApplyClicksArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsTotalApplyConfirmsArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsTotalApplyOpensArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsTotalUsersWithLinkedinUrlArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsWeekNewUsersArgs = {
  region?: InputMaybe<Scalars['String']>;
};


export type StatisticsWeekSavedJobsArgs = {
  region?: InputMaybe<Scalars['String']>;
};

export type StringListValue = {
  __typename: 'StringListValue';
  values: Array<Scalars['String']>;
};

export type StringResponse = {
  __typename: 'StringResponse';
  value: Scalars['String'];
};

export type StringValue = {
  __typename: 'StringValue';
  value: Scalars['String'];
};

export type SubmittedSalaryInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  currentExperienceLevel?: InputMaybe<ExperienceLevel>;
  currentSubFunctionId?: InputMaybe<Scalars['ID']>;
};

/** The possible options for technology preferences */
export enum TechnologyPreference {
  /** Must not have */
  Negative = 'NEGATIVE',
  /** Nice to have */
  Positive = 'POSITIVE',
  /** Great to have */
  VeryPositive = 'VERY_POSITIVE'
}

export type TechnologyUsedPreference = {
  __typename: 'TechnologyUsedPreference';
  technologyPreference: TechnologyPreference;
  technologyUsedId: Scalars['ID'];
};

export type TechnologyUsedPreferenceInput = {
  technologyPreference: TechnologyPreference;
  technologyUsedId: Scalars['ID'];
};

export type TextAnswer = {
  __typename: 'TextAnswer';
  questionData: AnswerQuestionData;
  value: Scalars['String'];
};

export type TextAnswerInput = {
  questionData: QuestionDataInput;
  value: Scalars['String'];
};

export type TextAreaAnswer = {
  __typename: 'TextAreaAnswer';
  questionData: AnswerQuestionData;
  value: Scalars['String'];
};

export type TextAreaAnswerInput = {
  questionData: QuestionDataInput;
  value: Scalars['String'];
};

export type TextAreaQuestion = {
  __typename: 'TextAreaQuestion';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type TextQuestion = {
  __typename: 'TextQuestion';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export enum ThemeId {
  ApplyViaOtta = 'APPLY_VIA_OTTA',
  FavouriteTechnologies = 'FAVOURITE_TECHNOLOGIES',
  FemaleFounders = 'FEMALE_FOUNDERS',
  FullyRemote = 'FULLY_REMOTE',
  HasSalaries = 'HAS_SALARIES',
  NewlyAdded = 'NEWLY_ADDED',
  PreferredSector = 'PREFERRED_SECTOR',
  RecentlyFunded = 'RECENTLY_FUNDED',
  TakeAnotherLook = 'TAKE_ANOTHER_LOOK',
  TechForGood = 'TECH_FOR_GOOD'
}

export type Timezone = {
  __typename: 'Timezone';
  id: Scalars['ID'];
  location: Scalars['String'];
  utcOffset: Scalars['Int'];
};

export type TopSectorTag = {
  __typename: 'TopSectorTag';
  category: Maybe<SectorCategory>;
  id: Scalars['ID'];
  numberCompanies: Scalars['Int'];
  value: Scalars['String'];
};

export type UrlAnswer = {
  __typename: 'UrlAnswer';
  questionData: AnswerQuestionData;
  value: Scalars['String'];
};

export type UrlAnswerInput = {
  questionData: QuestionDataInput;
  value: Scalars['String'];
};

export type UrlObject = {
  __typename: 'UrlObject';
  url: Scalars['String'];
};

export type UrlQuestion = {
  __typename: 'UrlQuestion';
  atsId: Maybe<Scalars['String']>;
  question: Scalars['String'];
  required: Scalars['Boolean'];
};

export type UrlResponse = {
  __typename: 'UrlResponse';
  url: Scalars['String'];
};

export type User = {
  __typename: 'User';
  activated: Scalars['Boolean'];
  companyQualitiesPreferences: Array<CompanyQualitiesPreference>;
  companySizePreferences: Array<CompanySizePreference>;
  companySubQualitiesPreferences: Array<CompanySubQualitiesPreference>;
  contextQuestionResponses: Array<CandidateContextQuestionResponse>;
  currentCompany: Maybe<Company>;
  currentTitle: Maybe<Scalars['String']>;
  discardedJobs: Array<Job>;
  discardedSubFunctions: Array<JobSubFunction>;
  educationExperiences: Array<UserEducationExperience>;
  email: Scalars['String'];
  ethnicities: Array<Ethnicity>;
  externalId: Scalars['ID'];
  firstName: Scalars['String'];
  genders: Array<Gender>;
  hasSetPreferences: Maybe<Scalars['Boolean']>;
  hasSubmittedSalary: Scalars['Boolean'];
  hiddenCompanies: Array<HiddenCompany>;
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  /** @deprecated Use job_applications instead */
  internalJobApplications: Array<JobApplication>;
  jobApplications: Array<JobApplication>;
  jobEmailNotificationsFrequency: NotificationFrequency;
  jobExperiencePreference: Maybe<JobExperiencePreference>;
  /** @deprecated Renamed to job_experience_preference */
  jobExperiencePreferences: Maybe<UserJobExperiencePreferences>;
  jobFunctionPreferences: Array<JobFunctionPreference>;
  /** @deprecated Unused - see job reaction statistics */
  jobInteractionStatistics: JobInteractionStatistics;
  jobNotificationUnsubscription: Scalars['Boolean'];
  jobPreferenceSuggestions: Maybe<Array<JobPreferenceSuggestion>>;
  jobReactionStatistics: JobReactionStatistics;
  jobRecommendations: Array<JobRecommendation>;
  jobSubFunctionPreferences: Array<JobSubFunctionPreference>;
  jobsProcessed: Maybe<Scalars['Int']>;
  languageRequirementPreferences: Array<LanguageRequirementPreference>;
  lastName: Scalars['String'];
  lastUnconfirmedJobApplication: Maybe<Scalars['String']>;
  linkedinUrl: Maybe<Scalars['String']>;
  locationPreferences: Array<LocationPreference>;
  marketingConsent: Scalars['Boolean'];
  /** @deprecated Use min_salary_requirement instead */
  minSalaryPreference: Maybe<Scalars['Int']>;
  minSalaryRequirement: Maybe<Money>;
  numReferrals: Maybe<Scalars['Int']>;
  numUnreadShortlistedJobs: Scalars['Int'];
  permissions: Array<PermissionObject>;
  phoneNumber: Maybe<Scalars['String']>;
  profileCompletion: Array<ProfileCompletionComponent>;
  profileImagePath: Maybe<Scalars['String']>;
  profileInterests: Maybe<Scalars['String']>;
  projects: Array<UserProject>;
  pronoun: Maybe<Pronoun>;
  receivedMessageRequests: Array<CandidateMessageRequest>;
  region: Maybe<Scalars['String']>;
  retained: Scalars['Boolean'];
  role: RoleType;
  searchStage: Maybe<Scalars['String']>;
  sectorTagPreferences: Array<SectorTagPreference>;
  sexualOrientation: Maybe<SexualOrientation>;
  shortlistedJobs: Array<Job>;
  showProfileToCompanies: Scalars['Boolean'];
  showRequestAdvice: Maybe<Scalars['Boolean']>;
  signUpReasonResponses: Array<SignUpReasonResponse>;
  signupRegion: Maybe<Scalars['String']>;
  signupSubregion: Maybe<Scalars['String']>;
  subregion: Maybe<Scalars['String']>;
  technologiesUsedPreferences: Array<TechnologyUsedPreference>;
  termsAndConditionsConsentedAt: Maybe<Scalars['NaiveDateTime']>;
  timezone: Maybe<Timezone>;
  totalDiscardedJobs: Maybe<Scalars['Int']>;
  totalJobApplicationClicks: Scalars['Int'];
  totalJobApplicationConfirms: Scalars['Int'];
  totalJobReactions: Scalars['Int'];
  totalRemainingJobs: Scalars['Int'];
  verifiedEmail: Scalars['Boolean'];
  visaRequirementCountries: Array<VisaRequirementCountry>;
  websiteLinks: Array<WebsiteLink>;
  workExperiences: Array<UserWorkExperience>;
};


export type UserDiscardedJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserJobApplicationsArgs = {
  applied?: InputMaybe<Scalars['Boolean']>;
  appliedAtGt?: InputMaybe<Scalars['DateTime']>;
  appliedAtLt?: InputMaybe<Scalars['DateTime']>;
  externalOrSentToAts?: InputMaybe<Scalars['Boolean']>;
  externalResponded?: InputMaybe<Array<ExternalResponded>>;
  internal?: InputMaybe<Scalars['Boolean']>;
  orderByLeastResponseRateDatapoints?: InputMaybe<Scalars['Boolean']>;
  stillApplied?: InputMaybe<Scalars['Boolean']>;
};


export type UserJobInteractionStatisticsArgs = {
  since: Scalars['NaiveDateTime'];
};


export type UserJobRecommendationsArgs = {
  ignoreSubfunctions?: InputMaybe<Scalars['Boolean']>;
  preferredSectorId?: InputMaybe<Scalars['ID']>;
  sectorTagIds?: InputMaybe<Array<Scalars['Int']>>;
  themeId?: InputMaybe<ThemeId>;
};


export type UserJobsProcessedArgs = {
  since: Scalars['DateTime'];
};


export type UserProfileImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};


export type UserTotalRemainingJobsArgs = {
  ignoreSubfunctions?: InputMaybe<Scalars['Boolean']>;
  sectorTagIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UserEducationExperience = {
  __typename: 'UserEducationExperience';
  description: Maybe<Scalars['String']>;
  descriptions: Array<EducationExperienceDescription>;
  educationType: Maybe<Scalars['String']>;
  endDate: Maybe<Scalars['Date']>;
  fieldOfStudy: Maybe<Scalars['String']>;
  grade: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institutionLinkedinUrl: Maybe<Scalars['String']>;
  institutionName: Scalars['String'];
  location: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['Date']>;
};

export type UserEducationExperienceInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<EducationExperienceDescriptionInput>>;
  educationType?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  fieldOfStudy?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Scalars['String']>;
  institutionLinkedinUrl?: InputMaybe<Scalars['String']>;
  institutionName: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

/** The fields a user is allowed to update about themselves */
export type UserInput = {
  companyQualitiesPreferences?: InputMaybe<Array<CompanyQualitiesPreferenceInput>>;
  companySizePreferences?: InputMaybe<Array<CompanySizePreferenceInput>>;
  currentCompanyId?: InputMaybe<Scalars['ID']>;
  currentTitle?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  ethnicities?: InputMaybe<Array<EthnicityInput>>;
  firstName?: InputMaybe<Scalars['String']>;
  genders?: InputMaybe<Array<Gender>>;
  hiddenCompanies?: InputMaybe<Array<HiddenCompanyInput>>;
  jobEmailNotificationsFrequency?: InputMaybe<NotificationFrequency>;
  jobExperiencePreference?: InputMaybe<JobExperiencePreferenceInput>;
  jobFunctionPreferences?: InputMaybe<Array<JobFunctionPreferenceInput>>;
  jobSubFunctionPreferences?: InputMaybe<Array<JobSubFunctionPreferenceInput>>;
  languageRequirementPreferences?: InputMaybe<Array<LanguageRequirementPreferenceInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locationPreferences?: InputMaybe<Array<LocationPreferenceInput>>;
  minSalaryPreference?: InputMaybe<Scalars['Int']>;
  minSalaryRequirement?: InputMaybe<MoneyInput>;
  numUnreadShortlistedJobs?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileInterests?: InputMaybe<Scalars['String']>;
  pronoun?: InputMaybe<Pronoun>;
  region?: InputMaybe<Scalars['String']>;
  searchStage?: InputMaybe<Scalars['String']>;
  sectorTagPreferences?: InputMaybe<Array<SectorTagPreferenceInput>>;
  sexualOrientation?: InputMaybe<SexualOrientation>;
  showProfileToCompanies?: InputMaybe<Scalars['Boolean']>;
  signUpReasonResponses?: InputMaybe<Array<SignUpReasonResponseInput>>;
  subregion?: InputMaybe<Scalars['String']>;
  technologiesUsedPreferences?: InputMaybe<Array<TechnologyUsedPreferenceInput>>;
  timezoneId?: InputMaybe<Scalars['ID']>;
  visaRequirementCountries?: InputMaybe<Array<VisaRequirementCountryInput>>;
  websiteLinks?: InputMaybe<Array<WebsiteLinkInput>>;
};

/** The fields a user is allowed to update about themselves via email */
export type UserInputViaEmail = {
  showProfileToCompanies?: InputMaybe<Scalars['Boolean']>;
};

export type UserJobExperiencePreferences = {
  __typename: 'UserJobExperiencePreferences';
  entryLevel: Scalars['Boolean'];
  fiveToEightYears: Scalars['Boolean'];
  id: Maybe<Scalars['ID']>;
  internship: Scalars['Boolean'];
  ninePlusYears: Scalars['Boolean'];
  oneToTwoYears: Scalars['Boolean'];
  showManagementRoles: Scalars['Boolean'];
  threeToFourYears: Scalars['Boolean'];
};

export enum UserJobStatus {
  ApplicationStarted = 'APPLICATION_STARTED',
  Applied = 'APPLIED',
  Interviewing = 'INTERVIEWING',
  NotSaved = 'NOT_SAVED',
  OfferAccepted = 'OFFER_ACCEPTED',
  OfferReceived = 'OFFER_RECEIVED',
  Saved = 'SAVED'
}

export type UserJobStatusInfo = {
  __typename: 'UserJobStatusInfo';
  status: UserJobStatus;
  subStatus: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type UserNotification = {
  __typename: 'UserNotification';
  dismissedAt: Maybe<Scalars['NaiveDateTime']>;
  id: Scalars['ID'];
  notification: Notification;
};

export type UserProfileView = {
  __typename: 'UserProfileView';
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  sessionLength: Scalars['Int'];
};

export type UserProject = {
  __typename: 'UserProject';
  description: Scalars['String'];
  endDate: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  imagePath: Maybe<Scalars['String']>;
  projectUrl: Maybe<Scalars['String']>;
  startDate: Maybe<Scalars['Date']>;
  technologiesUsed: Array<JobTechnologyUsed>;
  title: Scalars['String'];
};


export type UserProjectImagePathArgs = {
  prefix?: InputMaybe<Scalars['Boolean']>;
};

export type UserProjectInput = {
  description: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  projectUrl?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  technologiesUsed?: InputMaybe<Array<ProjectTechnologyUsedInput>>;
  title: Scalars['String'];
};

export type UserScrapeRequest = {
  __typename: 'UserScrapeRequest';
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  scrapedItems: Array<UserScrapeRequestScrapedItem>;
  status: ScrapeRequestStatus;
  url: Scalars['String'];
};

export type UserScrapeRequestScrapedItem = {
  __typename: 'UserScrapeRequestScrapedItem';
  data: Scalars['String'];
  id: Scalars['ID'];
  insertedAt: Scalars['NaiveDateTime'];
  url: Scalars['String'];
};

export type UserWorkExperience = {
  __typename: 'UserWorkExperience';
  companyDescription: Maybe<Scalars['String']>;
  companyLogoPath: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyOnOtta: Scalars['Boolean'];
  companyUrl: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  descriptions: Array<WorkExperienceDescription>;
  endDate: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  location: Maybe<Scalars['String']>;
  sectorTags: Array<SectorTag>;
  startDate: Scalars['Date'];
  technologiesUsed: Array<JobTechnologyUsed>;
  title: Scalars['String'];
};

export type UserWorkExperienceInput = {
  companyDescription?: InputMaybe<Scalars['String']>;
  companyLogoPath?: InputMaybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  descriptions?: InputMaybe<Array<WorkExperienceDescriptionInput>>;
  endDate?: InputMaybe<Scalars['Date']>;
  location?: InputMaybe<Scalars['String']>;
  sectorTags?: InputMaybe<Array<WorkExperienceSectorTagInput>>;
  startDate: Scalars['Date'];
  technologiesUsed?: InputMaybe<Array<WorkExperienceTechnologyUsedInput>>;
  title: Scalars['String'];
};

export type UserWorkExperienceSuggestion = {
  __typename: 'UserWorkExperienceSuggestion';
  id: Scalars['ID'];
  status: Maybe<WorkExperienceSuggestionStatus>;
  value: Array<Scalars['String']>;
};

export enum VisaRegion {
  Ca = 'CA',
  Eu = 'EU',
  Uk = 'UK',
  Us = 'US'
}

export type VisaRequirementCountry = {
  __typename: 'VisaRequirementCountry';
  id: Scalars['ID'];
  location: Scalars['String'];
};

export type VisaRequirementCountryInput = {
  location: Scalars['String'];
};

export type VisaSponsorshipCountry = {
  __typename: 'VisaSponsorshipCountry';
  id: Scalars['ID'];
  /** @deprecated Use region_id instead */
  location: Scalars['String'];
  offersVisa: Scalars['Boolean'];
  region: Region;
};

export type VisaSponsorshipCountryInput = {
  location?: InputMaybe<Scalars['String']>;
  offersVisa?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['ID']>;
};

export type WebsiteLink = {
  __typename: 'WebsiteLink';
  id: Scalars['ID'];
  linkType: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type WebsiteLinkInput = {
  linkType?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type WorkExperienceDescription = {
  __typename: 'WorkExperienceDescription';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type WorkExperienceDescriptionInput = {
  value: Scalars['String'];
};

export type WorkExperienceSectorTagInput = {
  id: Scalars['ID'];
};

export enum WorkExperienceSuggestionStatus {
  /** The candidate has accepted the suggestion */
  Accepted = 'ACCEPTED',
  /** The candidate has not yet taken action on the suggestion */
  Active = 'ACTIVE',
  /** The candidate has ignored the suggestion */
  Dismissed = 'DISMISSED'
}

export type WorkExperienceTechnologyUsedInput = {
  id: Scalars['ID'];
};

export type WorkableAnswer = BooleanAnswer | DateAnswer | DecimalAnswer | FileAnswer | MultiSelectAnswer | SingleSelectAnswer | TextAnswer | TextAreaAnswer;

export type WorkableAnswerData = {
  __typename: 'WorkableAnswerData';
  answers: Array<WorkableAnswer>;
};

export type WorkableAnswerInput = {
  booleanAnswer?: InputMaybe<BooleanAnswerInput>;
  dateAnswer?: InputMaybe<DateAnswerInput>;
  decimalAnswer?: InputMaybe<DecimalAnswerInput>;
  existingFileAnswer?: InputMaybe<ExistingFileAnswerInput>;
  fileAnswer?: InputMaybe<NewFileAnswerInput>;
  multiSelectAnswer?: InputMaybe<MultiSelectAnswerInput>;
  singleSelectAnswer?: InputMaybe<SingleSelectAnswerInput>;
  textAnswer?: InputMaybe<TextAnswerInput>;
  textAreaAnswer?: InputMaybe<TextAreaAnswerInput>;
};

export type WorkableApplicationQuestion = BooleanQuestion | DateQuestion | DecimalQuestion | FileQuestion | MultiSelectQuestion | SingleSelectQuestion | TextAreaQuestion | TextQuestion;

export type WorkableDataInput = {
  answers: Array<WorkableAnswerInput>;
};

export type WorkableQuestionData = {
  __typename: 'WorkableQuestionData';
  questions: Array<WorkableApplicationQuestion>;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { __typename: 'User', id: string, email: string, firstName: string, lastName: string, role: RoleType, retained: boolean, insertedAt: string, signupRegion: string | null, searchStage: string | null, profileCompletion: Array<ProfileCompletionComponent>, showProfileToCompanies: boolean, currentCompany: { __typename: 'Company', id: string, proTier: boolean } | null, jobFunctionPreferences: Array<{ __typename: 'JobFunctionPreference', functionId: string }>, jobSubFunctionPreferences: Array<{ __typename: 'JobSubFunctionPreference', subFunctionId: string }>, locationPreferences: Array<{ __typename: 'LocationPreference', id: string, location: Location }>, companySizePreferences: Array<{ __typename: 'CompanySizePreference', companySizeId: string }>, jobReactionStatistics: { __typename: 'JobReactionStatistics', numberJobsSeen: number, numberJobsSaved: number } } | null };


export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"retained"}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}},{"kind":"Field","name":{"kind":"Name","value":"currentCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proTier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobFunctionPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"functionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobSubFunctionPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subFunctionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signupRegion"}},{"kind":"Field","name":{"kind":"Name","value":"searchStage"}},{"kind":"Field","name":{"kind":"Name","value":"companySizePreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySizeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileCompletion"}},{"kind":"Field","name":{"kind":"Name","value":"showProfileToCompanies"}},{"kind":"Field","name":{"kind":"Name","value":"jobReactionStatistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberJobsSeen"}},{"kind":"Field","name":{"kind":"Name","value":"numberJobsSaved"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;